import { Injectable } from '@angular/core';
import { PastHistoryModel } from './HistoryModels/pasthistory.model';
import { SurgicalHistoryModel } from './HistoryModels/surgicalhistory.model';
import { FamilyHistoryModel } from './HistoryModels/familyhistory.model';
import { DrugAllergyModel } from './HistoryModels/drugallergy.model';
import { AdvisedInvModel } from './HistoryModels/advisedinvestigation.model';
import { PresentingComplaintsModel } from './PrimaryExaminationModels/presenting_complaints.model';
import { IntraocularPressureModel } from './PrimaryExaminationModels/intraocular_pressure.model';
import { FindingsModel } from './DoctorModels/findings.model';
import { InvestigationModel } from './DoctorModels/investigation.model';
import { DiagnosisModel } from './DoctorModels/diagnosis.model';
import { MedicineModal } from './DoctorModels/medicine.model';
import { SurgeryModel } from './DoctorModels/surgery.model';
import { HttpClient } from '@angular/common/http';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { DiabeticSurveyModel } from './HistoryModels/diabetic_survey.model';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { HistoryOtherInfoModel } from './HistoryModels/history_otherinfo.model';
import { DrugAllergySaveModel } from './HistoryModels/drug_allergy_save.model';
import { SiteloaderComponent } from 'app/auth/siteloader/siteloader.component';
import { MatDialog } from '@angular/material/dialog';
import { AutoRefModel } from './PrimaryExaminationModels/autoref.model';
import { OptoModel } from './PrimaryExaminationModels/opto.model';
import { StudentOptoModel } from './PrimaryExaminationModels/student_opto.model';
import { PatientEMRModel } from './HistoryModels/patientExaminationdata.model';
import { BehaviorSubject, Observable, Subject, Subscription, forkJoin, of } from 'rxjs';
import { AuthService } from 'app/auth/auth.service';
import { DatePipe } from '@angular/common';
import { OptoTestDetail } from './PrimaryExaminationModels/optoTestDetail.model';
import { DrworkupstatusModel } from './EMRModels/DrWorkupstatus.model';
import { WebmenupermissionModel } from './EMRModels/webMenuPermission.model';
import * as moment from 'moment';
import { OpdCounselorExamination } from './Counselor/CounselorModels/opd-counselor-examination.model';
import { pExamStatusModel } from './EMRModels/pexamSatus.model';
import { MatTableDataSource } from '@angular/material/table';
import { IoMethods } from './PrimaryExaminationModels/io_methods.model';
@Injectable({
  providedIn: 'root'
})
export class EMRService {
  // public unsubscribe = new Subject();

  selectedInvestigationRow: any;
  tabindex = 0;
  //testeyechk = "?";
  holdtimeAutoref: any;
  holdtimeopto: any;
  holdtimeDoctor: any;
  holdtimeCounselor: any;
  holdtimeprocedure: any;
  ar_value_box;
  keratometer_value_box;
  eyechkcategory;
  counselorExamModel: OpdCounselorExamination = {};
  branchmansterObj: any = {};
  autoref: AutoRefModel = {};
  enabledisablepog: boolean = false;
  enabledisableVision: boolean = false;
  enabledisableUd: boolean = false;
  enabledisableGP: boolean = false;
  enabledisableopt: boolean = false;
  enabledisableautorefkr: boolean = false;
  enabledisableautorefkr1: boolean = false;
  public enabledisablebtn: boolean = true;
  public enabledisablebtnInv: boolean = true;
  public enabledisablebtnDia: boolean = true;
  public enabledisablebtnMed: boolean = true;
  public enabledisablebtnSur: boolean = true;
  public enabledisablebtnRev: boolean = true;
  public enabledisablebtnInfo: boolean = true;
  public enabledisablebtnpasthistory: boolean = true;
  public enabledisablebtnsurhistory: boolean = true;
  public transferArray = new BehaviorSubject<any>([]);
  public transferArrayMedicine = new BehaviorSubject<any>([]);
  public transferArraydiagonsis = new BehaviorSubject<any>([]);
  public transferArraysurgery = new BehaviorSubject<any>([]);

  // ── AI Scribe: full-workup pending store ──────────────────────────────────
  // The page-level AI Scribe drops the extracted workup here. Each section
  // consumes (and clears) its own slice when its tab mounts, so one voice
  // recording pre-fills every section. aiWorkup$ notifies a currently-mounted
  // section to consume immediately.
  public aiWorkupPending: any = null;
  public aiWorkup$ = new Subject<any>();

  applyAiWorkup(sections: any): void {
    this.aiWorkupPending = sections || null;
    this.aiWorkup$.next(sections);
  }

  public medinicationMainArray: any = [];
  public mediciation_dss: MatTableDataSource<MedicineModal>
  public drugAllergydata: string = '';
  public sitelist: any = [];
  opto: OptoModel = {};
  optohelplist: OptoModel = {};
  public localStorePriscription: any = [];
  drWorkupStatus: DrworkupstatusModel = {}
  public content = new BehaviorSubject<string>('1');
  public share = this.content.asObservable();
  public contentpex = new BehaviorSubject<string>('pc');
  public pexshare = this.contentpex.asObservable();
  public contentiop = new BehaviorSubject<string>('iop');
  public iopshare = this.contentiop.asObservable();
  public contentot = new BehaviorSubject<string>('ot');
  public otshare = this.contentot.asObservable();
  public contentai = new BehaviorSubject<string>('ai');
  public aishare = this.contentai.asObservable();
  public contentosle = new BehaviorSubject<string>('osle');
  public osleshare = this.contentosle.asObservable();
  private componentClicked = new Subject<void>();
  componentClicked$ = this.componentClicked.asObservable();
  public issingleDrworkupsave: boolean = false;
  advisedinvestigation: AdvisedInvModel[] = [
    { AdvisedDate: "22/05/2018", InvestigationName: "ABC", Eye: "Left" },

  ]

  // public fontFamilies = {
  public fontFamilies = [
    { fontName: "apple-system" },
    { fontName: "Aqua Kana" },
    { fontName: "Aqua Kana Bold" },
    { fontName: "Helvetica LT MM" },
    { fontName: "Helvetica Neue Desk UI" },
    { fontName: "Helvetica Neue Desk UI Bold" },
    { fontName: "Helvetica Neue Desk UI Bold Italic" },
    { fontName: "Helvetica Neue Desk UI Italic" },
    { fontName: "Keyboard" },
    { fontName: "SFNSDisplay-Black" },
    { fontName: "SFNSDisplay-Bold" },
    { fontName: "SFNSDisplay-Heavy" },
    { fontName: "SFNSDisplay-Light" },
    { fontName: "SFNSDisplay-Medium" },
    { fontName: "SFNSDisplay-Regular" },
    { fontName: "SFNSDisplay-Semibold" },
    { fontName: "SFNSDisplay-Thin" },
    { fontName: "SFNSDisplay-Ultralight" },
    { fontName: "SFNSText-Bold" },
    { fontName: "SFNSText-BoldG1" },
    { fontName: "SFNSText-BoldG2" },
    { fontName: "SFNSText-BoldG3" },
    { fontName: "SFNSText-BoldItalic" },
    { fontName: "SFNSText-BoldItalicG1" },
    { fontName: "SFNSText-BoldItalicG2" },
    { fontName: "SFNSText-BoldItalicG3" },
    { fontName: "SFNSText-Heavy" },
    { fontName: "SFNSText-HeavyItalic" },
    { fontName: "SFNSText-Light" },
    { fontName: "SFNSText-LightItalic" },
    { fontName: "SFNSText-Medium" },
    { fontName: "SFNSText-MediumItalic" },
    { fontName: "SFNSText-Regular" },
    { fontName: "SFNSText-RegularG1" },
    { fontName: "SFNSText-RegularG2" },
    { fontName: "SFNSText-RegularG3" },
    { fontName: "SFNSText-RegularItalic" },
    { fontName: "SFNSText-RegularItalicG1" },
    { fontName: "SFNSText-RegularItalicG2" },
    { fontName: "SFNSText-RegularItalicG3" },
    { fontName: "SFNSText-Semibold" },
    { fontName: "SFNSText-SemiboldItalic" },
    { fontName: "Times LT MM" },
    { fontName: "28 Days Later" },
    { fontName: "AR PL UMing CN" },
    { fontName: "AR PL UMing HK" },
    { fontName: "AR PL UMing TW" },
    { fontName: "AR PL UMing TW MBE" },
    { fontName: "Abadi MT Condensed" },
    { fontName: "Abusive Pencil" },
    { fontName: "Abyssinica SIL" },
    { fontName: "Academy Engraved LET" },
    { fontName: "Academy Engraved LET Plain" },
    { fontName: "AcademyEngravedLetPlain" },
    { fontName: "Adobe Arabic" },
    { fontName: "Adobe Caslon Pro" },
    { fontName: "Adobe Devanagari" },
    { fontName: "Adobe Fan Heiti Std" },
    { fontName: "Adobe Fangsong Std" },
    { fontName: "Adobe Garamond Pro" },
    { fontName: "Adobe Gothic Std" },
    { fontName: "Adobe Hebrew" },
    { fontName: "Adobe Heiti Std" },
    { fontName: "Adobe Kaiti Std" },
    { fontName: "Adobe Ming Std" },
    { fontName: "Adobe Minion Web" },
    { fontName: "Adobe Myungjo Std" },
    { fontName: "Adobe Naskh" },
    { fontName: "Adobe Song Std" },
    { fontName: "Agency FB" },
    { fontName: "Aharoni" },
    { fontName: "Aharoni Bold" },
    { fontName: "Aierbazzi" },
    { fontName: "Al Bayan" },
    { fontName: "Al Bayan Bold" },
    { fontName: "Al Bayan Plain" },
    { fontName: "Al Nile" },
    { fontName: "Al Nile Bold" },
    { fontName: "Al Tarikh" },
    { fontName: "Al-Firat" },
    { fontName: "Al-Khalil" },
    { fontName: "Al-Khalil Bold" },
    { fontName: "Al-Rafidain" },
    { fontName: "Al-Rafidain Al-Fanni" },
    { fontName: "AlNile" },
    { fontName: "AlNile-Bold" },
    { fontName: "Aldhabi" },
    { fontName: "Algerian" },
    { fontName: "Algiers" },
    { fontName: "Almanac MT" },
    { fontName: "American Typewriter" },
    { fontName: "American Typewriter Bold" },
    { fontName: "American Typewriter Condensed" },
    { fontName: "American Typewriter Condensed Bold" },
    { fontName: "American Typewriter Condensed Light" },
    { fontName: "American Typewriter Light" },
    { fontName: "American Uncial" },
    { fontName: "AmericanTypewriter" },
    { fontName: "AmericanTypewriter-Bold" },
    { fontName: "AmericanTypewriter-Condensed" },
    { fontName: "AmericanTypewriter-CondensedBold" },
    { fontName: "AmericanTypewriter-CondensedLight" },
    { fontName: "AmericanTypewriter-Light" },
    { fontName: "Andale Mono" },
    { fontName: "Andalus" },
    { fontName: "Android Clock" },
    { fontName: "Android Emoji" },
    { fontName: "Andy" },
    { fontName: "Angelic War" },
    { fontName: "Angsana New" },
    { fontName: "Angsana New Bold" },
    { fontName: "Angsana New Bold Italic" },
    { fontName: "Angsana New Italic" },
    { fontName: "AngsanaUPC" },
    { fontName: "AngsanaUPC Bold" },
    { fontName: "AngsanaUPC Bold Italic" },
    { fontName: "AngsanaUPC Italic" },
    { fontName: "Aparajita" },
    { fontName: "Aparajita Bold" },
    { fontName: "Aparajita Bold Italic" },
    { fontName: "Aparajita Italic" },
    { fontName: "Apple Braille" },
    { fontName: "Apple Braille Outline 6 Dot" },
    { fontName: "Apple Braille Outline 8 Dot" },
    { fontName: "Apple Braille Pinpoint 6 Dot" },
    { fontName: "Apple Braille Pinpoint 8 Dot" },
    { fontName: "Apple Chancery" },
    { fontName: "Apple Color Emoji" },
    { fontName: "Apple LiGothic" },
    { fontName: "Apple LiGothic Medium" },
    { fontName: "Apple LiSung" },
    { fontName: "Apple LiSung Light" },
    { fontName: "Apple SD Gothic Neo" },
    { fontName: "Apple SD Gothic Neo Bold" },
    { fontName: "Apple SD Gothic Neo Heavy" },
    { fontName: "Apple SD Gothic Neo Light" },
    { fontName: "Apple SD Gothic Neo Medium" },
    { fontName: "Apple SD Gothic Neo Regular" },
    { fontName: "Apple SD Gothic Neo SemiBold" },
    { fontName: "Apple SD Gothic Neo Thin" },
    { fontName: "Apple SD Gothic Neo Ultra Light" },
    { fontName: "Apple SD Gothic Neo UltraLight" },
    { fontName: "Apple SD GothicNeo ExtraBold" },
    { fontName: "Apple Symbols" },
    { fontName: "AppleColorEmoji" },
    { fontName: "AppleGothic" },
    { fontName: "AppleGothic Regular" },
    { fontName: "AppleMyungjo" },
    { fontName: "AppleMyungjo Regular" },
    { fontName: "AppleSDGothicNeo-Bold" },
    { fontName: "AppleSDGothicNeo-Light" },
    { fontName: "AppleSDGothicNeo-Medium" },
    { fontName: "AppleSDGothicNeo-Regular" },
    { fontName: "AppleSDGothicNeo-SemiBold" },
    { fontName: "AppleSDGothicNeo-Thin" },
    { fontName: "AppleSDGothicNeo-UltraLight" },
    { fontName: "Arabic Transparent" },
    { fontName: "Arabic Transparent Bold" },
    { fontName: "Arabic Typesetting" },
    { fontName: "Arial" },
    { fontName: "Arial Black" },
    { fontName: "Arial Bold" },
    { fontName: "Arial Bold Italic" },
    { fontName: "Arial Hebrew" },
    { fontName: "Arial Hebrew Bold" },
    { fontName: "Arial Hebrew Light" },
    { fontName: "Arial Italic" },
    { fontName: "Arial Narrow" },
    { fontName: "Arial Narrow Bold" },
    { fontName: "Arial Narrow Bold Italic" },
    { fontName: "Arial Narrow Italic" },
    { fontName: "Arial Narrow Special" },
    { fontName: "Arial Rounded MT" },
    { fontName: "Arial Rounded MT Bold" },
    { fontName: "Arial Special" },
    { fontName: "Arial Unicode MS" },
    { fontName: "Arial-BoldItalicMT" },
    { fontName: "Arial-BoldMT" },
    { fontName: "Arial-ItalicMT" },
    { fontName: "ArialHebrew" },
    { fontName: "ArialHebrew-Bold" },
    { fontName: "ArialHebrew-Light" },
    { fontName: "ArialMT" },
    { fontName: "ArialRoundedMTBold" },
    { fontName: "Athelas" },
    { fontName: "Athelas Bold" },
    { fontName: "Athelas Bold Italic" },
    { fontName: "Athelas Italic" },
    { fontName: "Athelas Regular" },
    { fontName: "Augsburger Initials" },
    { fontName: "Avant Garde" },
    { fontName: "Avenir" },
    { fontName: "Avenir Black" },
    { fontName: "Avenir Black Oblique" },
    { fontName: "Avenir Book" },
    { fontName: "Avenir Book Oblique" },
    { fontName: "Avenir Heavy" },
    { fontName: "Avenir Heavy Oblique" },
    { fontName: "Avenir Light" },
    { fontName: "Avenir Light Oblique" },
    { fontName: "Avenir Medium" },
    { fontName: "Avenir Medium Oblique" },
    { fontName: "Avenir Next" },
    { fontName: "Avenir Next Bold" },
    { fontName: "Avenir Next Bold Italic" },
    { fontName: "Avenir Next Condensed" },
    { fontName: "Avenir Next Condensed Bold" },
    { fontName: "Avenir Next Condensed Bold Italic" },
    { fontName: "Avenir Next Condensed Demi Bold" },
    { fontName: "Avenir Next Condensed Demi Bold Italic" },
    { fontName: "Avenir Next Condensed Heavy" },
    { fontName: "Avenir Next Condensed Heavy Italic" },
    { fontName: "Avenir Next Condensed Italic" },
    { fontName: "Avenir Next Condensed Medium" },
    { fontName: "Avenir Next Condensed Medium Italic" },
    { fontName: "Avenir Next Condensed Regular" },
    { fontName: "Avenir Next Condensed Ultra Light" },
    { fontName: "Avenir Next Condensed Ultra Light Italic" },
    { fontName: "Avenir Next Demi Bold" },
    { fontName: "Avenir Next Demi Bold Italic" },
    { fontName: "Avenir Next Heavy" },
    { fontName: "Avenir Next Heavy Italic" },
    { fontName: "Avenir Next Italic" },
    { fontName: "Avenir Next Medium" },
    { fontName: "Avenir Next Medium Italic" },
    { fontName: "Avenir Next Regular" },
    { fontName: "Avenir Next Ultra Light" },
    { fontName: "Avenir Next Ultra Light Italic" },
    { fontName: "Avenir Oblique" },
    { fontName: "Avenir Roman" },
    { fontName: "Avenir-Black" },
    { fontName: "Avenir-BlackOblique" },
    { fontName: "Avenir-Book" },
    { fontName: "Avenir-BookOblique" },
    { fontName: "Avenir-Heavy" },
    { fontName: "Avenir-HeavyOblique" },
    { fontName: "Avenir-Light" },
    { fontName: "Avenir-LightOblique" },
    { fontName: "Avenir-Medium" },
    { fontName: "Avenir-MediumOblique" },
    { fontName: "Avenir-Oblique" },
    { fontName: "Avenir-Roman" },
    { fontName: "AvenirNext-Bold" },
    { fontName: "AvenirNext-BoldItalic" },
    { fontName: "AvenirNext-DemiBold" },
    { fontName: "AvenirNext-DemiBoldItalic" },
    { fontName: "AvenirNext-Heavy" },
    { fontName: "AvenirNext-HeavyItalic" },
    { fontName: "AvenirNext-Italic" },
    { fontName: "AvenirNext-Medium" },
    { fontName: "AvenirNext-MediumItalic" },
    { fontName: "AvenirNext-Regular" },
    { fontName: "AvenirNext-UltraLight" },
    { fontName: "AvenirNext-UltraLightItalic" },
    { fontName: "AvenirNextCondensed-Bold" },
    { fontName: "AvenirNextCondensed-BoldItalic" },
    { fontName: "AvenirNextCondensed-DemiBold" },
    { fontName: "AvenirNextCondensed-DemiBoldItalic" },
    { fontName: "AvenirNextCondensed-Heavy" },
    { fontName: "AvenirNextCondensed-HeavyItalic" },
    { fontName: "AvenirNextCondensed-Italic" },
    { fontName: "AvenirNextCondensed-Medium" },
    { fontName: "AvenirNextCondensed-MediumItalic" },
    { fontName: "AvenirNextCondensed-Regular" },
    { fontName: "AvenirNextCondensed-UltraLight" },
    { fontName: "AvenirNextCondensed-UltraLightItalic" },
    { fontName: "Ayuthaya" },
    { fontName: "BBAlpha Sans" },
    { fontName: "Bagarozz" },
    { fontName: "Baghdad" },
    { fontName: "Bangla MN" },
    { fontName: "Bangla MN Bold" },
    { fontName: "Bangla Sangam MN" },
    { fontName: "Bangla Sangam MN Bold" },
    { fontName: "Baoli SC" },
    { fontName: "Baoli SC Regular" },
    { fontName: "Base 02" },
    { fontName: "Baskerville" },
    { fontName: "Baskerville Bold" },
    { fontName: "Baskerville Bold Italic" },
    { fontName: "Baskerville Italic" },
    { fontName: "Baskerville Old Face" },
    { fontName: "Baskerville SemiBold" },
    { fontName: "Baskerville SemiBold Italic" },
    { fontName: "Baskerville-Bold" },
    { fontName: "Baskerville-BoldItalic" },
    { fontName: "Baskerville-Italic" },
    { fontName: "Baskerville-SemiBold" },
    { fontName: "Baskerville-SemiBoldItalic" },
    { fontName: "Basra" },
    { fontName: "Basra Bold" },
    { fontName: "Batang" },
    { fontName: "BatangChe" },
    { fontName: "Bauhaus 93" },
    { fontName: "Bebas" },
    { fontName: "Bebas Neue" },
    { fontName: "Beesknees ITC" },
    { fontName: "Beirut" },
    { fontName: "Bell MT" },
    { fontName: "Berlin Sans FB" },
    { fontName: "Bernard MT Condensed" },
    { fontName: "BiauKai" },
    { fontName: "Bickley Script" },
    { fontName: "Big Caslon" },
    { fontName: "Big Caslon Medium" },
    { fontName: "Birch Std" },
    { fontName: "Bitstream Charter" },
    { fontName: "Blackadder ITC" },
    { fontName: "Blackoak Std" },
    { fontName: "BlinkMacSystemFont" },
    { fontName: "Bodoni 72" },
    { fontName: "Bodoni 72 Bold" },
    { fontName: "Bodoni 72 Book" },
    { fontName: "Bodoni 72 Book Italic" },
    { fontName: "Bodoni 72 Oldstyle" },
    { fontName: "Bodoni 72 Oldstyle Bold" },
    { fontName: "Bodoni 72 Oldstyle Book" },
    { fontName: "Bodoni 72 Oldstyle Book Italic" },
    { fontName: "Bodoni 72 Smallcaps" },
    { fontName: "Bodoni 72 Smallcaps Book" },
    { fontName: "Bodoni MT" },
    { fontName: "Bodoni MT Condensed" },
    { fontName: "Bodoni Ornaments" },
    { fontName: "BodoniOrnamentsITCTT" },
    { fontName: "BodoniSvtyTwoITCTT-Bold" },
    { fontName: "BodoniSvtyTwoITCTT-Book" },
    { fontName: "BodoniSvtyTwoITCTT-BookIta" },
    { fontName: "BodoniSvtyTwoOSITCTT-Bold" },
    { fontName: "BodoniSvtyTwoOSITCTT-Book" },
    { fontName: "BodoniSvtyTwoOSITCTT-BookIt" },
    { fontName: "BodoniSvtyTwoSCITCTT-Book" },
    { fontName: "Bon Apetit MT" },
    { fontName: "Book Antiqua" },
    { fontName: "Book Antiqua Bold" },
    { fontName: "Book Antiqua Bold Italic" },
    { fontName: "Book Antiqua Italic" },
    { fontName: "Bookman Old Style" },
    { fontName: "Bookman Old Style Bold" },
    { fontName: "Bookman Old Style Bold Italic" },
    { fontName: "Bookman Old Style Italic" },
    { fontName: "Bookshelf Symbol" },
    { fontName: "Bradley Hand" },
    { fontName: "Bradley Hand Bold" },
    { fontName: "Bradley Hand ITC" },
    { fontName: "BradleyHandITCTT-Bold" },
    { fontName: "Braggadocio" },
    { fontName: "BriemScript" },
    { fontName: "Britannic" },
    { fontName: "Britannic Bold" },
    { fontName: "Broadway" },
    { fontName: "Browallia New" },
    { fontName: "Browallia New Bold" },
    { fontName: "Browallia New Bold Italic" },
    { fontName: "Browallia New Italic" },
    { fontName: "BrowalliaUPC" },
    { fontName: "BrowalliaUPC Bold" },
    { fontName: "BrowalliaUPC Bold Italic" },
    { fontName: "BrowalliaUPC Italic" },
    { fontName: "Brush Script MT" },
    { fontName: "Brush Script MT Italic" },
    { fontName: "Brush Script Std" },
    { fontName: "Caflisch Script" },
    { fontName: "Caflisch Script Regular" },
    { fontName: "Caladea" },
    { fontName: "Calibri" },
    { fontName: "Calibri Bold" },
    { fontName: "Calibri Bold Italic" },
    { fontName: "Calibri Italic" },
    { fontName: "Calibri Light" },
    { fontName: "Calibri Light Italic" },
    { fontName: "Californian FB" },
    { fontName: "Calisto MT" },
    { fontName: "Cambria" },
    { fontName: "Cambria Bold" },
    { fontName: "Cambria Bold Italic" },
    { fontName: "Cambria Italic" },
    { fontName: "Cambria Math" },
    { fontName: "Candara" },
    { fontName: "Candara Bold" },
    { fontName: "Candara Bold Italic" },
    { fontName: "Candara Italic" },
    { fontName: "Cantarell" },
    { fontName: "Cariadings" },
    { fontName: "Carlito" },
    { fontName: "Carrois Gothic SC" },
    { fontName: "Carrois Gothic SC Regular" },
    { fontName: "Castellar" },
    { fontName: "Casual" },
    { fontName: "Centaur" },
    { fontName: "Century" },
    { fontName: "Century Gothic" },
    { fontName: "Century Gothic Bold" },
    { fontName: "Century Gothic Bold Italic" },
    { fontName: "Century Gothic Italic" },
    { fontName: "Century Schoolbook" },
    { fontName: "Century Schoolbook Bold" },
    { fontName: "Century Schoolbook Bold Italic" },
    { fontName: "Century Schoolbook Italic" },
    { fontName: "Century Schoolbook L" },
    { fontName: "Chalkboard" },
    { fontName: "Chalkboard Bold" },
    { fontName: "Chalkboard SE" },
    { fontName: "Chalkboard SE Bold" },
    { fontName: "Chalkboard SE Light" },
    { fontName: "Chalkboard SE Regular" },
    { fontName: "ChalkboardSE-Bold" },
    { fontName: "ChalkboardSE-Light" },
    { fontName: "ChalkboardSE-Regular" },
    { fontName: "Chalkduster" },
    { fontName: "Champagne & Limousines" },
    { fontName: "Champagne & Limousines Thick" },
    { fontName: "Chaparral Pro" },
    { fontName: "Charcoal CY" },
    { fontName: "Charlemagne Std" },
    { fontName: "Charter" },
    { fontName: "Charter Black" },
    { fontName: "Charter Black Italic" },
    { fontName: "Charter Bold" },
    { fontName: "Charter Bold Italic" },
    { fontName: "Charter Italic" },
    { fontName: "Charter Roman" },
    { fontName: "Chiller" },
    { fontName: "ChunkFive" },
    { fontName: "Clockopia" },
    { fontName: "Cocaine Sans" },
    { fontName: "Cochin" },
    { fontName: "Cochin Bold" },
    { fontName: "Cochin Bold Italic" },
    { fontName: "Cochin Italic" },
    { fontName: "Cochin-Bold" },
    { fontName: "Cochin-BoldItalic" },
    { fontName: "Cochin-Italic" },
    { fontName: "Code Pro Demo" },
    { fontName: "Code Pro Light Demo" },
    { fontName: "Colonna MT" },
    { fontName: "Comic Sans MS" },
    { fontName: "Comic Sans MS Bold" },
    { fontName: "Comic Sans MS Bold Italic" },
    { fontName: "Comic Sans MS Italic" },
    { fontName: "Coming Soon" },
    { fontName: "Consolas" },
    { fontName: "Consolas Bold" },
    { fontName: "Consolas Bold Italic" },
    { fontName: "Consolas Italic" },
    { fontName: "Constantia" },
    { fontName: "Constantia Bold" },
    { fontName: "Constantia Bold Italic" },
    { fontName: "Constantia Italic" },
    { fontName: "Contemporary Brush" },
    { fontName: "Cooper Black" },
    { fontName: "Cooper Std" },
    { fontName: "Copperplate" },
    { fontName: "Copperplate Bold" },
    { fontName: "Copperplate Gothic" },
    { fontName: "Copperplate Light" },
    { fontName: "Copperplate-Bold" },
    { fontName: "Copperplate-Light" },
    { fontName: "Corbel" },
    { fontName: "Corbel Bold" },
    { fontName: "Corbel Bold Italic" },
    { fontName: "Corbel Italic" },
    { fontName: "Cordia New" },
    { fontName: "Cordia New Bold" },
    { fontName: "Cordia New Bold Italic" },
    { fontName: "Cordia New Italic" },
    { fontName: "CordiaUPC" },
    { fontName: "CordiaUPC Bold" },
    { fontName: "CordiaUPC Bold Italic" },
    { fontName: "CordiaUPC Italic" },
    { fontName: "Corsiva Hebrew" },
    { fontName: "Corsiva Hebrew Bold" },
    { fontName: "Courier" },
    { fontName: "Courier 10 Pitch" },
    { fontName: "Courier Bold" },
    { fontName: "Courier Bold Oblique" },
    { fontName: "Courier New" },
    { fontName: "Courier New Bold" },
    { fontName: "Courier New Bold Italic" },
    { fontName: "Courier New Italic" },
    { fontName: "Courier Oblique" },
    { fontName: "Courier-Bold" },
    { fontName: "Courier-BoldOblique" },
    { fontName: "Courier-Oblique" },
    { fontName: "CourierNewPS-BoldItalicMT" },
    { fontName: "CourierNewPS-BoldMT" },
    { fontName: "CourierNewPS-ItalicMT" },
    { fontName: "CourierNewPSMT" },
    { fontName: "Critter" },
    { fontName: "Curlz MT" },
    { fontName: "Cursor" },
    { fontName: "Cutive Mono" },
    { fontName: "DB LCD Temp" },
    { fontName: "DFKai-SB" },
    { fontName: "DIN Alternate" },
    { fontName: "DIN Alternate Bold" },
    { fontName: "DIN Condensed" },
    { fontName: "DIN Condensed Bold" },
    { fontName: "Damascus" },
    { fontName: "Damascus Bold" },
    { fontName: "Damascus Light" },
    { fontName: "Damascus Medium" },
    { fontName: "Damascus Semi Bold" },
    { fontName: "DamascusBold" },
    { fontName: "DamascusLight" },
    { fontName: "DamascusMedium" },
    { fontName: "DamascusSemiBold" },
    { fontName: "Dancing Script" },
    { fontName: "Dancing Script Bold" },
    { fontName: "Dancing Script Regular" },
    { fontName: "DaunPenh" },
    { fontName: "David" },
    { fontName: "David Bold" },
    { fontName: "David Transparent" },
    { fontName: "DecoType Naskh" },
    { fontName: "DejaVu Sans" },
    { fontName: "DejaVu Sans Condensed" },
    { fontName: "DejaVu Sans Light" },
    { fontName: "DejaVu Sans Mono" },
    { fontName: "DejaVu Serif" },
    { fontName: "DejaVu Serif Condensed" },
    { fontName: "Desdemona" },
    { fontName: "Devanagari MT" },
    { fontName: "Devanagari MT Bold" },
    { fontName: "Devanagari Sangam MN" },
    { fontName: "Devanagari Sangam MN Bold" },
    { fontName: "DevanagariSangamMN" },
    { fontName: "DevanagariSangamMN-Bold" },
    { fontName: "Didot" },
    { fontName: "Didot Bold" },
    { fontName: "Didot Italic" },
    { fontName: "Didot-Bold" },
    { fontName: "Didot-Italic" },
    { fontName: "Digital-7" },
    { fontName: "Dijla" },
    { fontName: "DilleniaUPC" },
    { fontName: "DilleniaUPC Bold" },
    { fontName: "DilleniaUPC Bold Italic" },
    { fontName: "DilleniaUPC Italic" },
    { fontName: "DingMaps" },
    { fontName: "Dingbats" },
    { fontName: "Directions MT" },
    { fontName: "Dirt2 SoulStalker" },
    { fontName: "Diwan Kufi" },
    { fontName: "Diwan Mishafi" },
    { fontName: "Diwan Thuluth" },
    { fontName: "DiwanMishafi" },
    { fontName: "DokChampa" },
    { fontName: "Dotum" },
    { fontName: "DotumChe" },
    { fontName: "Droid Arabic Naskh" },
    { fontName: "Droid Kufi" },
    { fontName: "Droid Naskh" },
    { fontName: "Droid Sans" },
    { fontName: "Droid Sans Armenian" },
    { fontName: "Droid Sans Ethiopic" },
    { fontName: "Droid Sans Fallback" },
    { fontName: "Droid Sans Georgian" },
    { fontName: "Droid Sans Hebrew" },
    { fontName: "Droid Sans Japanese" },
    { fontName: "Droid Sans Mono" },
    { fontName: "Droid Sans Pro" },
    { fontName: "Droid Sans Pro Condensed" },
    { fontName: "Droid Sans Pro Mono" },
    { fontName: "Droid Sans Thai" },
    { fontName: "Droid Serif" },
    { fontName: "Droid Serif Pro" },
    { fontName: "Droid Serif Regular" },
    { fontName: "Ebrima" },
    { fontName: "Ebrima Bold" },
    { fontName: "Eckmann" },
    { fontName: "Edda" },
    { fontName: "Edwardian Script ITC" },
    { fontName: "Eeyek Unicode" },
    { fontName: "Elephant" },
    { fontName: "Engravers MT" },
    { fontName: "Enviro" },
    { fontName: "Eras ITC" },
    { fontName: "Eraser" },
    { fontName: "Estrangelo Edessa" },
    { fontName: "EucrosiaUPC" },
    { fontName: "EucrosiaUPC Bold" },
    { fontName: "EucrosiaUPC Bold Italic" },
    { fontName: "EucrosiaUPC Italic" },
    { fontName: "Euphemia" },
    { fontName: "Euphemia UCAS" },
    { fontName: "Euphemia UCAS Bold" },
    { fontName: "Euphemia UCAS Italic" },
    { fontName: "EuphemiaUCAS" },
    { fontName: "EuphemiaUCAS-Bold" },
    { fontName: "EuphemiaUCAS-Italic" },
    { fontName: "Eurostile" },
    { fontName: "FFF Tusj" },
    { fontName: "Faith Collapsing" },
    { fontName: "FangSong" },
    { fontName: "Farah" },
    { fontName: "Farisi" },
    { fontName: "Felix Titling" },
    { fontName: "Fine Hand" },
    { fontName: "Fixed Miriam Transparent" },
    { fontName: "Flexure" },
    { fontName: "Footlight MT" },
    { fontName: "Forte" },
    { fontName: "FrankRuehl" },
    { fontName: "Franklin Gothic" },
    { fontName: "Franklin Gothic Medium" },
    { fontName: "Franklin Gothic Medium Italic" },
    { fontName: "FreeMono" },
    { fontName: "FreeSans" },
    { fontName: "FreeSerif" },
    { fontName: "FreesiaUPC" },
    { fontName: "FreesiaUPC Bold" },
    { fontName: "FreesiaUPC Bold Italic" },
    { fontName: "FreesiaUPC Italic" },
    { fontName: "Freestyle Script" },
    { fontName: "French Script MT" },
    { fontName: "Futura" },
    { fontName: "Futura Condensed ExtraBold" },
    { fontName: "Futura Condensed Medium" },
    { fontName: "Futura Medium" },
    { fontName: "Futura Medium Italic" },
    { fontName: "Futura-CondensedExtraBold" },
    { fontName: "Futura-CondensedMedium" },
    { fontName: "Futura-Medium" },
    { fontName: "Futura-MediumItalic" },
    { fontName: "GB18030 Bitmap" },
    { fontName: "Gabriola" },
    { fontName: "Gadugi" },
    { fontName: "Gadugi Bold" },
    { fontName: "Garamond" },
    { fontName: "Garamond Bold" },
    { fontName: "Garamond Bold Italic" },
    { fontName: "Garamond Italic" },
    { fontName: "Garamond MT" },
    { fontName: "Garuda" },
    { fontName: "Gautami" },
    { fontName: "Gautami Bold" },
    { fontName: "Geeza Pro" },
    { fontName: "Geeza Pro Bold" },
    { fontName: "Geeza Pro Light" },
    { fontName: "GeezaPro" },
    { fontName: "GeezaPro-Bold" },
    { fontName: "Geneva" },
    { fontName: "Geneva CY" },
    { fontName: "Georgia" },
    { fontName: "Georgia Bold" },
    { fontName: "Georgia Bold Italic" },
    { fontName: "Georgia Italic" },
    { fontName: "Georgia Ref" },
    { fontName: "Georgia-Bold" },
    { fontName: "Georgia-BoldItalic" },
    { fontName: "Georgia-Italic" },
    { fontName: "Giddyup Std" },
    { fontName: "Gigi" },
    { fontName: "Gill Sans" },
    { fontName: "Gill Sans Bold" },
    { fontName: "Gill Sans Bold Italic" },
    { fontName: "Gill Sans Italic" },
    { fontName: "Gill Sans Light" },
    { fontName: "Gill Sans Light Italic" },
    { fontName: "Gill Sans MT" },
    { fontName: "Gill Sans MT Bold" },
    { fontName: "Gill Sans MT Bold Italic" },
    { fontName: "Gill Sans MT Condensed" },
    { fontName: "Gill Sans MT Italic" },
    { fontName: "Gill Sans MT Ultra Bold" },
    { fontName: "Gill Sans MT Ultra Bold Condensed" },
    { fontName: "Gill Sans SemiBold" },
    { fontName: "Gill Sans SemiBold Italic" },
    { fontName: "Gill Sans UltraBold" },
    { fontName: "GillSans" },
    { fontName: "GillSans-Bold" },
    { fontName: "GillSans-BoldItalic" },
    { fontName: "GillSans-Italic" },
    { fontName: "GillSans-Light" },
    { fontName: "GillSans-LightItalic" },
    { fontName: "GillSans-SemiBold" },
    { fontName: "GillSans-SemiBoldItalic" },
    { fontName: "GillSans-UltraBold" },
    { fontName: "Gisha" },
    { fontName: "Gisha Bold" },
    { fontName: "Gloucester" },
    { fontName: "Gotham" },
    { fontName: "GothamCondensed" },
    { fontName: "Goudy" },
    { fontName: "Goudy Old Style" },
    { fontName: "Goudy Stout" },
    { fontName: "Gradl" },
    { fontName: "Gujarati MT" },
    { fontName: "Gujarati MT Bold" },
    { fontName: "Gujarati Sangam MN" },
    { fontName: "Gujarati Sangam MN Bold" },
    { fontName: "GujaratiSangamMN" },
    { fontName: "GujaratiSangamMN-Bold" },
    { fontName: "Gulim" },
    { fontName: "GulimChe" },
    { fontName: "GungSeo" },
    { fontName: "GungSeo Regular" },
    { fontName: "Gungsuh" },
    { fontName: "GungsuhChe" },
    { fontName: "Gurmukhi MN" },
    { fontName: "Gurmukhi MN Bold" },
    { fontName: "Gurmukhi MT" },
    { fontName: "Gurmukhi Sangam MN" },
    { fontName: "Gurmukhi Sangam MN Bold" },
    { fontName: "GurmukhiMN" },
    { fontName: "GurmukhiMN-Bold" },
    { fontName: "Haettenschweiler" },
    { fontName: "Handset Condensed" },
    { fontName: "Hannotate SC" },
    { fontName: "Hannotate SC Bold" },
    { fontName: "Hannotate SC Regular" },
    { fontName: "Hannotate TC" },
    { fontName: "Hannotate TC Bold" },
    { fontName: "Hannotate TC Regular" },
    { fontName: "HanziPen SC" },
    { fontName: "HanziPen SC Bold" },
    { fontName: "HanziPen SC Regular" },
    { fontName: "HanziPen TC" },
    { fontName: "HanziPen TC Bold" },
    { fontName: "HanziPen TC Regular" },
    { fontName: "Harlow Solid Italic" },
    { fontName: "Harrington" },
    { fontName: "Hawaii Lover" },
    { fontName: "HeadLineA" },
    { fontName: "HeadLineA Regular" },
    { fontName: "Hei" },
    { fontName: "Hei Regular" },
    { fontName: "Heiti SC" },
    { fontName: "Heiti SC Light" },
    { fontName: "Heiti SC Medium" },
    { fontName: "Heiti TC" },
    { fontName: "Heiti TC Light" },
    { fontName: "Heiti TC Medium" },
    { fontName: "Helvetica" },
    { fontName: "Helvetica Bold" },
    { fontName: "Helvetica Bold Oblique" },
    { fontName: "Helvetica CY" },
    { fontName: "Helvetica CY Bold" },
    { fontName: "Helvetica CY BoldOblique" },
    { fontName: "Helvetica CY Oblique" },
    { fontName: "Helvetica CY Plain" },
    { fontName: "Helvetica Light" },
    { fontName: "Helvetica Light Oblique" },
    { fontName: "Helvetica Neue" },
    { fontName: "Helvetica Neue Bold" },
    { fontName: "Helvetica Neue Bold Italic" },
    { fontName: "Helvetica Neue Condensed Black" },
    { fontName: "Helvetica Neue Condensed Bold" },
    { fontName: "Helvetica Neue Italic" },
    { fontName: "Helvetica Neue Light" },
    { fontName: "Helvetica Neue Light Italic" },
    { fontName: "Helvetica Neue Medium" },
    { fontName: "Helvetica Neue Medium Italic" },
    { fontName: "Helvetica Neue Thin" },
    { fontName: "Helvetica Neue Thin Italic" },
    { fontName: "Helvetica Neue UltraLight" },
    { fontName: "Helvetica Neue UltraLight Italic" },
    { fontName: "Helvetica Oblique" },
    { fontName: "Helvetica-Bold" },
    { fontName: "Helvetica-BoldOblique" },
    { fontName: "Helvetica-Light" },
    { fontName: "Helvetica-LightOblique" },
    { fontName: "Helvetica-Oblique" },
    { fontName: "HelveticaNeue" },
    { fontName: "HelveticaNeue-Bold" },
    { fontName: "HelveticaNeue-BoldItalic" },
    { fontName: "HelveticaNeue-CondensedBlack" },
    { fontName: "HelveticaNeue-CondensedBold" },
    { fontName: "HelveticaNeue-Italic" },
    { fontName: "HelveticaNeue-Light" },
    { fontName: "HelveticaNeue-LightItalic" },
    { fontName: "HelveticaNeue-Medium" },
    { fontName: "HelveticaNeue-MediumItalic" },
    { fontName: "HelveticaNeue-Thin" },
    { fontName: "HelveticaNeue-ThinItalic" },
    { fontName: "HelveticaNeue-UltraLight" },
    { fontName: "HelveticaNeue-UltraLightItalic" },
    { fontName: "Herculanum" },
    { fontName: "High Tower Text" },
    { fontName: "HiraMinProN-W3" },
    { fontName: "HiraMinProN-W6" },
    { fontName: "Hiragino Kaku Gothic Pro" },
    { fontName: "Hiragino Kaku Gothic Pro W3" },
    { fontName: "Hiragino Kaku Gothic Pro W6" },
    { fontName: "Hiragino Kaku Gothic ProN" },
    { fontName: "Hiragino Kaku Gothic ProN W3" },
    { fontName: "Hiragino Kaku Gothic ProN W6" },
    { fontName: "Hiragino Kaku Gothic Std" },
    { fontName: "Hiragino Kaku Gothic Std W8" },
    { fontName: "Hiragino Kaku Gothic StdN" },
    { fontName: "Hiragino Kaku Gothic StdN W8" },
    { fontName: "Hiragino Maru Gothic Pro" },
    { fontName: "Hiragino Maru Gothic Pro W4" },
    { fontName: "Hiragino Maru Gothic ProN" },
    { fontName: "Hiragino Maru Gothic ProN W4" },
    { fontName: "Hiragino Mincho Pro" },
    { fontName: "Hiragino Mincho Pro W3" },
    { fontName: "Hiragino Mincho Pro W6" },
    { fontName: "Hiragino Mincho ProN" },
    { fontName: "Hiragino Mincho ProN W3" },
    { fontName: "Hiragino Mincho ProN W6" },
    { fontName: "Hiragino Sans GB" },
    { fontName: "Hiragino Sans GB W3" },
    { fontName: "Hiragino Sans GB W6" },
    { fontName: "HiraginoSans-W3" },
    { fontName: "HiraginoSans-W6" },
    { fontName: "Hobo Std" },
    { fontName: "Hoefler Text" },
    { fontName: "Hoefler Text Black" },
    { fontName: "Hoefler Text Black Italic" },
    { fontName: "Hoefler Text Italic" },
    { fontName: "Hoefler Text Ornaments" },
    { fontName: "HoeflerText-Black" },
    { fontName: "HoeflerText-BlackItalic" },
    { fontName: "HoeflerText-Italic" },
    { fontName: "HoeflerText-Regular" },
    { fontName: "Holidays MT" },
    { fontName: "Hotel Coral Essex" },
    { fontName: "ITC Stone Serif" },
    { fontName: "Impact" },
    { fontName: "Imprint MT Shadow" },
    { fontName: "InaiMathi" },
    { fontName: "Informal Roman" },
    { fontName: "Input Mono" },
    { fontName: "Input Mono Compressed" },
    { fontName: "Input Mono Condensed" },
    { fontName: "Input Mono Narrow" },
    { fontName: "Input Sans" },
    { fontName: "Input Sans Compressed" },
    { fontName: "Input Sans Condensed" },
    { fontName: "Input Sans Narrow" },
    { fontName: "Input Serif" },
    { fontName: "Input Serif Compressed" },
    { fontName: "Input Serif Condensed" },
    { fontName: "Input Serif Narrow" },
    { fontName: "Iowan Old Style" },
    { fontName: "Iowan Old Style Black" },
    { fontName: "Iowan Old Style Black Italic" },
    { fontName: "Iowan Old Style Bold" },
    { fontName: "Iowan Old Style Bold Italic" },
    { fontName: "Iowan Old Style Italic" },
    { fontName: "Iowan Old Style Roman" },
    { fontName: "Iowan Old Style Titling" },
    { fontName: "IowanOldStyle-Bold" },
    { fontName: "IowanOldStyle-BoldItalic" },
    { fontName: "IowanOldStyle-Italic" },
    { fontName: "IowanOldStyle-Roman" },
    { fontName: "IrisUPC" },
    { fontName: "IrisUPC Bold" },
    { fontName: "IrisUPC Bold Italic" },
    { fontName: "IrisUPC Italic" },
    { fontName: "Iskoola Pota" },
    { fontName: "Iskoola Pota Bold" },
    { fontName: "IskoolaPota-Bold" },
    { fontName: "JasmineUPC" },
    { fontName: "JasmineUPC Bold" },
    { fontName: "JasmineUPC Bold Italic" },
    { fontName: "JasmineUPC Italic" },
    { fontName: "Jellyka Gare de Chambord" },
    { fontName: "Jokerman" },
    { fontName: "Jomolhari" },
    { fontName: "Juice ITC" },
    { fontName: "KacstArt" },
    { fontName: "KacstBook" },
    { fontName: "KacstDecorative" },
    { fontName: "KacstDigital" },
    { fontName: "KacstFarsi" },
    { fontName: "KacstLetter" },
    { fontName: "KacstNaskh" },
    { fontName: "KacstOffice" },
    { fontName: "KacstOne" },
    { fontName: "KacstPen" },
    { fontName: "KacstPoster" },
    { fontName: "KacstQurn" },
    { fontName: "KacstScreen" },
    { fontName: "KacstTitle" },
    { fontName: "KacstTitleL" },
    { fontName: "Kai" },
    { fontName: "Kai Regular" },
    { fontName: "KaiTi" },
    { fontName: "Kailasa" },
    { fontName: "Kailasa Bold" },
    { fontName: "Kailasa Regular" },
    { fontName: "Kailasa-Bold" },
    { fontName: "Kaiti SC" },
    { fontName: "Kaiti SC Black" },
    { fontName: "Kaiti SC Bold" },
    { fontName: "Kaiti SC Regular" },
    { fontName: "Kaiti TC" },
    { fontName: "Kaiti TC Bold" },
    { fontName: "Kaiti TC Regular" },
    { fontName: "Kalinga" },
    { fontName: "Kalinga Bold" },
    { fontName: "Kannada MN" },
    { fontName: "Kannada MN Bold" },
    { fontName: "Kannada Sangam MN" },
    { fontName: "Kannada Sangam MN Bold" },
    { fontName: "KannadaSangamMN" },
    { fontName: "KannadaSangamMN-Bold" },
    { fontName: "Kartika" },
    { fontName: "Kartika Bold" },
    { fontName: "Kedage" },
    { fontName: "Kefa" },
    { fontName: "Kefa Bold" },
    { fontName: "Kefa Regular" },
    { fontName: "Keystrokes MT" },
    { fontName: "Khmer MN" },
    { fontName: "Khmer MN Bold" },
    { fontName: "Khmer OS" },
    { fontName: "Khmer OS Content" },
    { fontName: "Khmer OS System" },
    { fontName: "Khmer Sangam MN" },
    { fontName: "Khmer UI" },
    { fontName: "Khmer UI Bold" },
    { fontName: "KhmerSangamMN" },
    { fontName: "Kinnari" },
    { fontName: "Kino MT" },
    { fontName: "KodchiangUPC" },
    { fontName: "KodchiangUPC Bold" },
    { fontName: "KodchiangUPC Bold Italic" },
    { fontName: "KodchiangUPC Italic" },
    { fontName: "Kohinoor Devanagari" },
    { fontName: "Kohinoor Devanagari Book" },
    { fontName: "Kohinoor Devanagari Light" },
    { fontName: "Kohinoor Devanagari Medium" },
    { fontName: "KohinoorBangla-Light" },
    { fontName: "KohinoorBangla-Regular" },
    { fontName: "KohinoorBangla-Semibold" },
    { fontName: "KohinoorDevanagari" },
    { fontName: "KohinoorDevanagari-Light" },
    { fontName: "KohinoorDevanagari-Regular" },
    { fontName: "KohinoorDevanagari-Semibold" },
    { fontName: "KohinoorTelugu-Light" },
    { fontName: "KohinoorTelugu-Medium" },
    { fontName: "KohinoorTelugu-Regular" },
    { fontName: "Kokila" },
    { fontName: "Kokila Bold" },
    { fontName: "Kokila Bold Italic" },
    { fontName: "Kokila Italic" },
    { fontName: "Kokonor" },
    { fontName: "Kokonor Regular" },
    { fontName: "Koufi Abjadi" },
    { fontName: "Kozuka Gothic Pr6N" },
    { fontName: "Kozuka Gothic Pro" },
    { fontName: "Kozuka Mincho Pr6N" },
    { fontName: "Kozuka Mincho Pro" },
    { fontName: "Kremlin" },
    { fontName: "Kristen ITC" },
    { fontName: "Krungthep" },
    { fontName: "KufiStandardGK" },
    { fontName: "Kunstler Script" },
    { fontName: "LCD" },
    { fontName: "LCDMono" },
    { fontName: "LCDMono2" },
    { fontName: "LKLUG" },
    { fontName: "Laimoon" },
    { fontName: "Lantinghei SC" },
    { fontName: "Lantinghei SC Demibold" },
    { fontName: "Lantinghei SC Extralight" },
    { fontName: "Lantinghei SC Heavy" },
    { fontName: "Lantinghei TC" },
    { fontName: "Lantinghei TC Demibold" },
    { fontName: "Lantinghei TC Extralight" },
    { fontName: "Lantinghei TC Heavy" },
    { fontName: "Lao MN" },
    { fontName: "Lao MN Bold" },
    { fontName: "Lao Sangam MN" },
    { fontName: "Lao UI" },
    { fontName: "Lao UI Bold" },
    { fontName: "LaoSangamMN" },
    { fontName: "LastResort" },
    { fontName: "Latha" },
    { fontName: "Latha Bold" },
    { fontName: "League Gothic" },
    { fontName: "Leelawadee" },
    { fontName: "Leelawadee Bold" },
    { fontName: "Letter Gothic Std" },
    { fontName: "Levenim MT" },
    { fontName: "Levenim MT Bold" },
    { fontName: "LiHei Pro" },
    { fontName: "LiSong Pro" },
    { fontName: "Liberation Mono" },
    { fontName: "Liberation Sans" },
    { fontName: "Liberation Sans Narrow" },
    { fontName: "Liberation Serif" },
    { fontName: "Libian SC" },
    { fontName: "Libian SC Regular" },
    { fontName: "LilyUPC" },
    { fontName: "LilyUPC Bold" },
    { fontName: "LilyUPC Bold Italic" },
    { fontName: "LilyUPC Italic" },
    { fontName: "Lithos Pro" },
    { fontName: "Lohit Assamese" },
    { fontName: "Lohit Bengali" },
    { fontName: "Lohit Devanagari" },
    { fontName: "Lohit Gujarati" },
    { fontName: "Lohit Kannada" },
    { fontName: "Lohit Malayalam" },
    { fontName: "Lohit Oriya" },
    { fontName: "Lohit Punjabi" },
    { fontName: "Lohit Tamil" },
    { fontName: "Lohit Telugu" },
    { fontName: "Loma" },
    { fontName: "Lucida Blackletter" },
    { fontName: "Lucida Bright" },
    { fontName: "Lucida Bright Math" },
    { fontName: "Lucida Calligraphy" },
    { fontName: "Lucida Console" },
    { fontName: "Lucida Fax" },
    { fontName: "Lucida Grande" },
    { fontName: "Lucida Grande Bold" },
    { fontName: "Lucida Handwriting" },
    { fontName: "Lucida Sans" },
    { fontName: "Lucida Sans Typewriter" },
    { fontName: "Lucida Sans Unicode" },
    { fontName: "MS Gothic" },
    { fontName: "MS LineDraw" },
    { fontName: "MS Mincho" },
    { fontName: "MS Outlook" },
    { fontName: "MS PGothic" },
    { fontName: "MS PMincho" },
    { fontName: "MS Reference" },
    { fontName: "MS UI Gothic" },
    { fontName: "MT Extra" },
    { fontName: "MV Boli" },
    { fontName: "Magneto" },
    { fontName: "Maiandra GD" },
    { fontName: "Malayalam MN" },
    { fontName: "Malayalam MN Bold" },
    { fontName: "Malayalam Sangam MN" },
    { fontName: "Malayalam Sangam MN Bold" },
    { fontName: "MalayalamSangamMN" },
    { fontName: "MalayalamSangamMN-Bold" },
    { fontName: "Malgun Gothic" },
    { fontName: "Malgun Gothic Bold" },
    { fontName: "Mallige" },
    { fontName: "Mangal" },
    { fontName: "Mangal Bold" },
    { fontName: "Map Symbols" },
    { fontName: "Marion" },
    { fontName: "Marion Bold" },
    { fontName: "Marion Italic" },
    { fontName: "Marion Regular" },
    { fontName: "Marker Felt" },
    { fontName: "Marker Felt Thin" },
    { fontName: "Marker Felt Wide" },
    { fontName: "MarkerFelt-Thin" },
    { fontName: "MarkerFelt-Wide" },
    { fontName: "Marlett" },
    { fontName: "Matisse ITC" },
    { fontName: "Matura MT Script Capitals" },
    { fontName: "McZee" },
    { fontName: "Mead Bold" },
    { fontName: "Meera" },
    { fontName: "Meiryo" },
    { fontName: "Meiryo Bold" },
    { fontName: "Meiryo Bold Italic" },
    { fontName: "Meiryo Italic" },
    { fontName: "Meiryo UI" },
    { fontName: "Meiryo UI Bold" },
    { fontName: "Meiryo UI Bold Italic" },
    { fontName: "Meiryo UI Italic" },
    { fontName: "Menlo" },
    { fontName: "Menlo Bold" },
    { fontName: "Menlo Bold Italic" },
    { fontName: "Menlo Italic" },
    { fontName: "Menlo Regular" },
    { fontName: "Menlo-Bold" },
    { fontName: "Menlo-BoldItalic" },
    { fontName: "Menlo-Italic" },
    { fontName: "Menlo-Regular" },
    { fontName: "Mercurius Script MT Bold" },
    { fontName: "Mesquite Std" },
    { fontName: "Microsoft Himalaya" },
    { fontName: "Microsoft JhengHei" },
    { fontName: "Microsoft JhengHei Bold" },
    { fontName: "Microsoft JhengHei UI" },
    { fontName: "Microsoft JhengHei UI Bold" },
    { fontName: "Microsoft New Tai Lue" },
    { fontName: "Microsoft New Tai Lue Bold" },
    { fontName: "Microsoft PhagsPa" },
    { fontName: "Microsoft PhagsPa Bold" },
    { fontName: "Microsoft Sans Serif" },
    { fontName: "Microsoft Tai Le" },
    { fontName: "Microsoft Tai Le Bold" },
    { fontName: "Microsoft Uighur" },
    { fontName: "Microsoft Uighur Bold" },
    { fontName: "Microsoft YaHei" },
    { fontName: "Microsoft YaHei Bold" },
    { fontName: "Microsoft YaHei UI" },
    { fontName: "Microsoft YaHei UI Bold" },
    { fontName: "Microsoft Yi Baiti" },
    { fontName: "MingLiU" },
    { fontName: "MingLiU-ExtB" },
    { fontName: "MingLiU_HKSCS" },
    { fontName: "MingLiU_HKSCS-ExtB" },
    { fontName: "Mingzat" },
    { fontName: "Minion Pro" },
    { fontName: "Minion Web" },
    { fontName: "Miriam" },
    { fontName: "Miriam Fixed" },
    { fontName: "Miriam Transparent" },
    { fontName: "Mishafi" },
    { fontName: "Mistral" },
    { fontName: "Modern No. 20" },
    { fontName: "Monaco" },
    { fontName: "Mongolian Baiti" },
    { fontName: "Monotype Corsiva" },
    { fontName: "Monotype Sorts" },
    { fontName: "Monotype.com" },
    { fontName: "MoolBoran" },
    { fontName: "Mshtakan" },
    { fontName: "Mshtakan Bold" },
    { fontName: "Mshtakan BoldOblique" },
    { fontName: "Mshtakan Oblique" },
    { fontName: "Mukti Narrow" },
    { fontName: "Muna" },
    { fontName: "Muna Black" },
    { fontName: "Muna Bold" },
    { fontName: "Museo Sans" },
    { fontName: "Museo Slab" },
    { fontName: "Myanmar MN" },
    { fontName: "Myanmar MN Bold" },
    { fontName: "Myanmar Sangam MN" },
    { fontName: "Myanmar Text" },
    { fontName: "Myriad Arabic" },
    { fontName: "Myriad Hebrew" },
    { fontName: "Myriad Pro" },
    { fontName: "NSimSun" },
    { fontName: "Nadeem" },
    { fontName: "Nanum Brush Script" },
    { fontName: "Nanum Gothic" },
    { fontName: "Nanum Myeongjo" },
    { fontName: "Nanum Pen Script" },
    { fontName: "NanumBarunGothic" },
    { fontName: "NanumGothic" },
    { fontName: "NanumGothic Bold" },
    { fontName: "NanumGothic ExtraBold" },
    { fontName: "NanumGothicExtraBold" },
    { fontName: "NanumMyeongjo" },
    { fontName: "NanumMyeongjo Bold" },
    { fontName: "NanumMyeongjo ExtraBold" },
    { fontName: "Narkisim" },
    { fontName: "New Caledonia" },
    { fontName: "New Peninim MT" },
    { fontName: "New Peninim MT Bold" },
    { fontName: "New Peninim MT Bold Inclined" },
    { fontName: "New Peninim MT Inclined" },
    { fontName: "News Gothic MT" },
    { fontName: "Niagara" },
    { fontName: "Nimbus Mono L" },
    { fontName: "Nimbus Roman No9 L" },
    { fontName: "Nimbus Sans L" },
    { fontName: "Nirmala UI" },
    { fontName: "Nirmala UI Bold" },
    { fontName: "Nisan" },
    { fontName: "Norasi" },
    { fontName: "Noteworthy" },
    { fontName: "Noteworthy Bold" },
    { fontName: "Noteworthy Light" },
    { fontName: "Noteworthy-Bold" },
    { fontName: "Noteworthy-Light" },
    { fontName: "Noto Sans CJK" },
    { fontName: "Noto Sans Lisu" },
    { fontName: "Noto Sans Mandaic" },
    { fontName: "Noto Sans Meetei Mayek" },
    { fontName: "Noto Sans Tagalog" },
    { fontName: "Noto Sans Tai Tham" },
    { fontName: "Noto Sans Tai Viet" },
    { fontName: "Noto Serif" },
    { fontName: "Noto Serif Bold" },
    { fontName: "Noto Serif Bold Italic" },
    { fontName: "Noto Serif Regular" },
    { fontName: "Noto Serif Regular Italic" },
    { fontName: "Nueva Std" },
    { fontName: "Nuosu SIL" },
    { fontName: "Nyala" },
    { fontName: "Nymphette" },
    { fontName: "OCR A Extended" },
    { fontName: "OCR A Std" },
    { fontName: "OCR-B-Digits" },
    { fontName: "OCRB" },
    { fontName: "Old English Text MT" },
    { fontName: "Onyx" },
    { fontName: "OpenSymbol" },
    { fontName: "Optima" },
    { fontName: "Optima Bold" },
    { fontName: "Optima Bold Italic" },
    { fontName: "Optima ExtraBlack" },
    { fontName: "Optima Italic" },
    { fontName: "Optima Regular" },
    { fontName: "Optima-Bold" },
    { fontName: "Optima-BoldItalic" },
    { fontName: "Optima-ExtraBlack" },
    { fontName: "Optima-Italic" },
    { fontName: "Optima-Regular" },
    { fontName: "Orator Std" },
    { fontName: "Orial_" },
    { fontName: "Oriya MN" },
    { fontName: "Oriya MN Bold" },
    { fontName: "Oriya Sangam MN" },
    { fontName: "Oriya Sangam MN Bold" },
    { fontName: "OriyaSangamMN" },
    { fontName: "OriyaSangamMN-Bold" },
    { fontName: "Osaka" },
    { fontName: "Osaka-Mono" },
    { fontName: "Ostrich Sans" },
    { fontName: "Ostrich Sans Dashed" },
    { fontName: "Ostrich Sans Rounded" },
    { fontName: "PCMyungjo" },
    { fontName: "PCMyungjo Regular" },
    { fontName: "PMingLiU" },
    { fontName: "PMingLiU-ExtB" },
    { fontName: "PT Mono" },
    { fontName: "PT Mono Bold" },
    { fontName: "PT Sans" },
    { fontName: "PT Sans Bold" },
    { fontName: "PT Sans Bold Italic" },
    { fontName: "PT Sans Caption" },
    { fontName: "PT Sans Caption Bold" },
    { fontName: "PT Sans Italic" },
    { fontName: "PT Sans Narrow" },
    { fontName: "PT Sans Narrow Bold" },
    { fontName: "PT Serif" },
    { fontName: "PT Serif Bold" },
    { fontName: "PT Serif Bold Italic" },
    { fontName: "PT Serif Caption" },
    { fontName: "PT Serif Caption Italic" },
    { fontName: "PT Serif Italic" },
    { fontName: "Pacifico" },
    { fontName: "Padauk" },
    { fontName: "Padauk Book" },
    { fontName: "PakType Naqsh" },
    { fontName: "Palace Script MT" },
    { fontName: "Palatino" },
    { fontName: "Palatino Bold" },
    { fontName: "Palatino Bold Italic" },
    { fontName: "Palatino Italic" },
    { fontName: "Palatino Linotype" },
    { fontName: "Palatino Linotype Bold" },
    { fontName: "Palatino Linotype Bold Italic" },
    { fontName: "Palatino Linotype Italic" },
    { fontName: "Palatino-Bold" },
    { fontName: "Palatino-BoldItalic" },
    { fontName: "Palatino-Italic" },
    { fontName: "Palatino-Roman" },
    { fontName: "Papyrus" },
    { fontName: "Papyrus Condensed" },
    { fontName: "Papyrus-Condensed" },
    { fontName: "Parade" },
    { fontName: "Parchment" },
    { fontName: "Parties MT" },
    { fontName: "Party LET" },
    { fontName: "Party LET Plain" },
    { fontName: "PartyLetPlain" },
    { fontName: "Patua One" },
    { fontName: "Peignot Medium" },
    { fontName: "Pepita MT" },
    { fontName: "Perpetua" },
    { fontName: "Perpetua Titling MT" },
    { fontName: "Phetsarath OT" },
    { fontName: "PilGi" },
    { fontName: "PilGi Regular" },
    { fontName: "PingFangHK-Light" },
    { fontName: "PingFangHK-Medium" },
    { fontName: "PingFangHK-Regular" },
    { fontName: "PingFangHK-Semibold" },
    { fontName: "PingFangHK-Thin" },
    { fontName: "PingFangHK-Ultralight" },
    { fontName: "PingFangSC-Light" },
    { fontName: "PingFangSC-Medium" },
    { fontName: "PingFangSC-Regular" },
    { fontName: "PingFangSC-Semibold" },
    { fontName: "PingFangSC-Thin" },
    { fontName: "PingFangSC-Ultralight" },
    { fontName: "PingFangTC-Light" },
    { fontName: "PingFangTC-Medium" },
    { fontName: "PingFangTC-Regular" },
    { fontName: "PingFangTC-Semibold" },
    { fontName: "PingFangTC-Thin" },
    { fontName: "PingFangTC-Ultralight" },
    { fontName: "Placard Condensed" },
    { fontName: "Plantagenet Cherokee" },
    { fontName: "Playbill" },
    { fontName: "Pointy" },
    { fontName: "Poor Richard" },
    { fontName: "Poplar Std" },
    { fontName: "Pothana2000" },
    { fontName: "Prestige Elite Std" },
    { fontName: "Pricedown" },
    { fontName: "Pristina" },
    { fontName: "Proxima Nova" },
    { fontName: "Proxima Nova Condensed" },
    { fontName: "Purisa" },
    { fontName: "Raanana" },
    { fontName: "Raanana Bold" },
    { fontName: "Raavi" },
    { fontName: "Raavi Bold" },
    { fontName: "Rachana" },
    { fontName: "Rage Italic" },
    { fontName: "Rambla" },
    { fontName: "Ransom" },
    { fontName: "Ravie" },
    { fontName: "Raya" },
    { fontName: "RefSpecialty" },
    { fontName: "Rekha" },
    { fontName: "Riesling" },
    { fontName: "Roboto" },
    { fontName: "Roboto Black" },
    { fontName: "Roboto Black Italic" },
    { fontName: "Roboto Bold" },
    { fontName: "Roboto Bold Italic" },
    { fontName: "Roboto Condensed" },
    { fontName: "Roboto Condensed Bold" },
    { fontName: "Roboto Condensed Light" },
    { fontName: "Roboto Italic" },
    { fontName: "Roboto Light" },
    { fontName: "Roboto Light Italic" },
    { fontName: "Roboto Medium" },
    { fontName: "Roboto Medium Italic" },
    { fontName: "Roboto Regular" },
    { fontName: "Roboto Slab" },
    { fontName: "Roboto Thin" },
    { fontName: "Roboto Thin Italic" },
    { fontName: "Rockwell" },
    { fontName: "Rockwell Condensed" },
    { fontName: "Rockwell Extra Bold" },
    { fontName: "Rod" },
    { fontName: "Rod Transparent" },
    { fontName: "Rosewood Std" },
    { fontName: "Rudiment" },
    { fontName: "Runic MT Condensed" },
    { fontName: "STFangsong" },
    { fontName: "STHeiti" },
    { fontName: "STIXGeneral" },
    { fontName: "STIXGeneral-Bold" },
    { fontName: "STIXGeneral-BoldItalic" },
    { fontName: "STIXGeneral-Italic" },
    { fontName: "STIXGeneral-Regular" },
    { fontName: "STIXIntegralsD" },
    { fontName: "STIXIntegralsD-Bold" },
    { fontName: "STIXIntegralsD-Regular" },
    { fontName: "STIXIntegralsSm" },
    { fontName: "STIXIntegralsSm-Bold" },
    { fontName: "STIXIntegralsSm-Regular" },
    { fontName: "STIXIntegralsUp" },
    { fontName: "STIXIntegralsUp-Bold" },
    { fontName: "STIXIntegralsUp-Regular" },
    { fontName: "STIXIntegralsUpD" },
    { fontName: "STIXIntegralsUpD-Bold" },
    { fontName: "STIXIntegralsUpD-Regular" },
    { fontName: "STIXIntegralsUpSm" },
    { fontName: "STIXIntegralsUpSm-Bold" },
    { fontName: "STIXIntegralsUpSm-Regular" },
    { fontName: "STIXNonUnicode" },
    { fontName: "STIXNonUnicode-Bold" },
    { fontName: "STIXNonUnicode-BoldItalic" },
    { fontName: "STIXNonUnicode-Italic" },
    { fontName: "STIXNonUnicode-Regular" },
    { fontName: "STIXSizeFiveSym" },
    { fontName: "STIXSizeFiveSym-Regular" },
    { fontName: "STIXSizeFourSym" },
    { fontName: "STIXSizeFourSym-Bold" },
    { fontName: "STIXSizeFourSym-Regular" },
    { fontName: "STIXSizeOneSym" },
    { fontName: "STIXSizeOneSym-Bold" },
    { fontName: "STIXSizeOneSym-Regular" },
    { fontName: "STIXSizeThreeSym" },
    { fontName: "STIXSizeThreeSym-Bold" },
    { fontName: "STIXSizeThreeSym-Regular" },
    { fontName: "STIXSizeTwoSym" },
    { fontName: "STIXSizeTwoSym-Bold" },
    { fontName: "STIXSizeTwoSym-Regular" },
    { fontName: "STIXVariants" },
    { fontName: "STIXVariants-Bold" },
    { fontName: "STIXVariants-Regular" },
    { fontName: "STKaiti" },
    { fontName: "STSong" },
    { fontName: "STXihei" },
    { fontName: "Saab" },
    { fontName: "Sakkal Majalla" },
    { fontName: "Sakkal Majalla Bold" },
    { fontName: "San Francisco" },
    { fontName: "Sana" },
    { fontName: "Sansa Soft Std" },
    { fontName: "Sathu" },
    { fontName: "Savoye LET" },
    { fontName: "Savoye LET Plain" },
    { fontName: "Savoye LET Plain CC" },
    { fontName: "Savoye LET Plain CC." },
    { fontName: "Savoye LET Plain CC.:1.0" },
    { fontName: "Savoye LET Plain:1.0" },
    { fontName: "Savoye Let Plain" },
    { fontName: "SavoyeLetPlain" },
    { fontName: "Sawasdee" },
    { fontName: "Script MT Bold" },
    { fontName: "Segoe Chess" },
    { fontName: "Segoe Print" },
    { fontName: "Segoe Print Bold" },
    { fontName: "Segoe Pseudo" },
    { fontName: "Segoe Script" },
    { fontName: "Segoe Script Bold" },
    { fontName: "Segoe UI" },
    { fontName: "Segoe UI Bold" },
    { fontName: "Segoe UI Bold Italic" },
    { fontName: "Segoe UI Italic" },
    { fontName: "Segoe UI Light" },
    { fontName: "Segoe UI Light Italic" },
    { fontName: "Segoe UI Semibold" },
    { fontName: "Segoe UI Semibold Italic" },
    { fontName: "Segoe UI Semilight" },
    { fontName: "Segoe UI Semilight Italic" },
    { fontName: "Segoe UI Symbol" },
    { fontName: "Seravek" },
    { fontName: "Seravek Bold" },
    { fontName: "Seravek Bold Italic" },
    { fontName: "Seravek ExtraLight" },
    { fontName: "Seravek ExtraLight Italic" },
    { fontName: "Seravek Italic" },
    { fontName: "Seravek Light" },
    { fontName: "Seravek Light Italic" },
    { fontName: "Seravek Medium" },
    { fontName: "Seravek Medium Italic" },
    { fontName: "Shonar Bangla" },
    { fontName: "Shonar Bangla Bold" },
    { fontName: "Showcard Gothic" },
    { fontName: "Shruti" },
    { fontName: "Shruti Bold" },
    { fontName: "Signs MT" },
    { fontName: "Silom" },
    { fontName: "SimHei" },
    { fontName: "SimSun" },
    { fontName: "SimSun-ExtB" },
    { fontName: "Simplified Arabic" },
    { fontName: "Simplified Arabic Bold" },
    { fontName: "Simplified Arabic Fixed" },
    { fontName: "Sinhala MN" },
    { fontName: "Sinhala MN Bold" },
    { fontName: "Sinhala Sangam MN" },
    { fontName: "Sinhala Sangam MN Bold" },
    { fontName: "SinhalaSangamMN" },
    { fontName: "SinhalaSangamMN-Bold" },
    { fontName: "Skia" },
    { fontName: "Skia Regular" },
    { fontName: "Snap ITC" },
    { fontName: "Snell Roundhand" },
    { fontName: "Snell Roundhand Black" },
    { fontName: "Snell Roundhand Bold" },
    { fontName: "SnellRoundhand" },
    { fontName: "SnellRoundhand-Black" },
    { fontName: "SnellRoundhand-Bold" },
    { fontName: "Sofia Pro" },
    { fontName: "Somer" },
    { fontName: "Songti SC" },
    { fontName: "Songti SC Black" },
    { fontName: "Songti SC Bold" },
    { fontName: "Songti SC Light" },
    { fontName: "Songti SC Regular" },
    { fontName: "Songti TC" },
    { fontName: "Songti TC Bold" },
    { fontName: "Songti TC Light" },
    { fontName: "Songti TC Regular" },
    { fontName: "Source Sans Pro" },
    { fontName: "Sports MT" },
    { fontName: "Standard Symbols L" },
    { fontName: "Stencil" },
    { fontName: "Stencil Std" },
    { fontName: "Stop" },
    { fontName: "Superclarendon" },
    { fontName: "Superclarendon Black" },
    { fontName: "Superclarendon Black Italic" },
    { fontName: "Superclarendon Bold" },
    { fontName: "Superclarendon Bold Italic" },
    { fontName: "Superclarendon Italic" },
    { fontName: "Superclarendon Light" },
    { fontName: "Superclarendon Light Italic" },
    { fontName: "Superclarendon Regular" },
    { fontName: "Sylfaen" },
    { fontName: "Symbol" },
    { fontName: "System Font" },
    { fontName: "System Font Bold" },
    { fontName: "System Font Regular" },
    { fontName: "THE MAPLE ORIGINS" },
    { fontName: "TOSCA ZERO" },
    { fontName: "Tahoma" },
    { fontName: "Tahoma Bold" },
    { fontName: "Tahoma Negreta" },
    { fontName: "TakaoPGothic" },
    { fontName: "Tamil MN" },
    { fontName: "Tamil MN Bold" },
    { fontName: "Tamil Sangam MN" },
    { fontName: "Tamil Sangam MN Bold" },
    { fontName: "TamilSangamMN" },
    { fontName: "TamilSangamMN-Bold" },
    { fontName: "Tekton Pro" },
    { fontName: "Telugu MN" },
    { fontName: "Telugu MN Bold" },
    { fontName: "Telugu Sangam MN" },
    { fontName: "Telugu Sangam MN Bold" },
    { fontName: "TeluguSangamMN" },
    { fontName: "Temp Installer Font" },
    { fontName: "Tempo Grunge" },
    { fontName: "Tempus Sans ITC" },
    { fontName: "Thonburi" },
    { fontName: "Thonburi Bold" },
    { fontName: "Thonburi Light" },
    { fontName: "Thonburi-Bold" },
    { fontName: "Thonburi-Light" },
    { fontName: "Tibetan Machine Uni" },
    { fontName: "Times" },
    { fontName: "Times Bold" },
    { fontName: "Times Bold Italic" },
    { fontName: "Times Italic" },
    { fontName: "Times New Roman" },
    { fontName: "Times New Roman Bold" },
    { fontName: "Times New Roman Bold Italic" },
    { fontName: "Times New Roman Italic" },
    { fontName: "Times New Roman Special" },
    { fontName: "Times New Yorker" },
    { fontName: "Times Roman" },
    { fontName: "TimesNewRomanPS-BoldItalicMT" },
    { fontName: "TimesNewRomanPS-BoldMT" },
    { fontName: "TimesNewRomanPS-ItalicMT" },
    { fontName: "TimesNewRomanPSMT" },
    { fontName: "Tlwg Typist" },
    { fontName: "Tlwg Typo" },
    { fontName: "TlwgMono" },
    { fontName: "TlwgTypewriter" },
    { fontName: "Traditional Arabic" },
    { fontName: "Traditional Arabic Bold" },
    { fontName: "Trajan Pro" },
    { fontName: "Transport MT" },
    { fontName: "Trebuchet MS" },
    { fontName: "Trebuchet MS Bold" },
    { fontName: "Trebuchet MS Bold Italic" },
    { fontName: "Trebuchet MS Italic" },
    { fontName: "Trebuchet-BoldItalic" },
    { fontName: "TrebuchetMS" },
    { fontName: "TrebuchetMS-Bold" },
    { fontName: "TrebuchetMS-Italic" },
    { fontName: "Tunga" },
    { fontName: "Tunga Bold" },
    { fontName: "Tw Cen MT" },
    { fontName: "Tw Cen MT Bold" },
    { fontName: "Tw Cen MT Bold Italic" },
    { fontName: "Tw Cen MT Condensed" },
    { fontName: "Tw Cen MT Italic" },
    { fontName: "URW Bookman L" },
    { fontName: "URW Chancery L" },
    { fontName: "URW Gothic L" },
    { fontName: "URW Palladio L" },
    { fontName: "Ubuntu" },
    { fontName: "Ubuntu Condensed" },
    { fontName: "Ubuntu Light" },
    { fontName: "Ubuntu Medium" },
    { fontName: "Ubuntu Mono" },
    { fontName: "Umpush" },
    { fontName: "Univers" },
    { fontName: "Urdu Typesetting" },
    { fontName: "Utopia" },
    { fontName: "Utsaah" },
    { fontName: "Utsaah Bold" },
    { fontName: "Utsaah Bold Italic" },
    { fontName: "Utsaah Italic" },
    { fontName: "VL Gothic" },
    { fontName: "Vacation MT" },
    { fontName: "Vani" },
    { fontName: "Vani Bold" },
    { fontName: "Vemana2000" },
    { fontName: "Verdana" },
    { fontName: "Verdana Bold" },
    { fontName: "Verdana Bold Italic" },
    { fontName: "Verdana Italic" },
    { fontName: "Verdana Ref" },
    { fontName: "Verdana-Bold" },
    { fontName: "Verdana-BoldItalic" },
    { fontName: "Verdana-Italic" },
    { fontName: "Verlag" },
    { fontName: "Verlag Compressed" },
    { fontName: "Verlag Condensed" },
    { fontName: "Vijaya" },
    { fontName: "Vijaya Bold" },
    { fontName: "Viner Hand ITC" },
    { fontName: "Vivaldi" },
    { fontName: "Vixar ASCI" },
    { fontName: "Vladimir Script" },
    { fontName: "Vrinda" },
    { fontName: "Vrinda Bold" },
    { fontName: "Vtks Revolt" },
    { fontName: "Waree" },
    { fontName: "Waseem" },
    { fontName: "Waseem Light" },
    { fontName: "Wawati SC" },
    { fontName: "Wawati SC Regular" },
    { fontName: "Wawati TC" },
    { fontName: "Wawati TC Regular" },
    { fontName: "Webdings" },
    { fontName: "Weibei SC" },
    { fontName: "Weibei SC Bold" },
    { fontName: "Weibei TC" },
    { fontName: "Weibei TC Bold" },
    { fontName: "WenQuanYi Zen Hei" },
    { fontName: "WenQuanYi Zen Hei Mono" },
    { fontName: "WenQuanYi Zen Hei Sharp" },
    { fontName: "Western" },
    { fontName: "Westminster" },
    { fontName: "Wide Latin" },
    { fontName: "Wingdings" },
    { fontName: "Wingdings 2" },
    { fontName: "Wingdings 3" },
    { fontName: "Xingkai SC" },
    { fontName: "Xingkai SC Bold" },
    { fontName: "Xingkai SC Light" },
    { fontName: "Yaziji" },
    { fontName: "YuGothic" },
    { fontName: "YuGothic Bold" },
    { fontName: "YuGothic Medium" },
    { fontName: "YuMincho" },
    { fontName: "YuMincho Demibold" },
    { fontName: "YuMincho Medium" },
    { fontName: "Yuanti SC" },
    { fontName: "Yuanti SC Bold" },
    { fontName: "Yuanti SC Light" },
    { fontName: "Yuanti SC Regular" },
    { fontName: "Yuppy SC" },
    { fontName: "Yuppy SC Regular" },
    { fontName: "Yuppy TC" },
    { fontName: "Yuppy TC Regular" },
    { fontName: "Zapf Chancery" },
    { fontName: "Zapf Dingbats" },
    { fontName: "ZapfDingbatsITC" },
    { fontName: "Zapfino" },
    { fontName: "Zawra Bold" },
    { fontName: "Zawra Heavy" },
    { fontName: "[ank]*" },
    { fontName: "cursive" },
    { fontName: "fantasy" },
    { fontName: "gargi" },
    { fontName: "green piloww" },
    { fontName: "jersey stories!" },
    { fontName: "karabinE." },
    { fontName: "monospace" },
    { fontName: "mry_KacstQurn" },
    { fontName: "ori1Uni" },
    { fontName: "route 3" },
    { fontName: "sans-serif" },
    { fontName: "sans-serif-black" },
    { fontName: "sans-serif-condensed" },
    { fontName: "sans-serif-condensed-light" },
    { fontName: "sans-serif-light" },
    { fontName: "sans-serif-medium" },
    { fontName: "sans-serif-monospace" },
    { fontName: "sans-serif-smallcaps" },
    { fontName: "sans-serif-thin" },
    { fontName: "serif" },
    { fontName: "serif-monospace" },
    { fontName: "utkal" }
  ]
    ;
  delete_flag = null;



  // History Module ***********************************************************

  diabetic_survey: DiabeticSurveyModel = {};







  drugallergy_added: DrugAllergyModel = {};
  public patientEMRdetail: PatientEMRModel[] = [];

  drugallergy: DrugAllergyModel[] = [

  ]

  drugallergy_saved: DrugAllergySaveModel[] = [];


  familyhistory_added: FamilyHistoryModel = {};

  familyhistory: FamilyHistoryModel[] = [

  ]

  surgeryhistory_added: SurgicalHistoryModel = {};

  surgicalhistory: SurgicalHistoryModel[] = [


  ]
  surgicalhistory_client: SurgicalHistoryModel[] = [

  ]

  pasthistory_added: PastHistoryModel = {};

  pasthistory: PastHistoryModel[] = [

  ]
  pasthistory_client: PastHistoryModel[] = [

  ]

  otherinfo_history: HistoryOtherInfoModel = {};

  // History Module Ends ********************************************************


  // Primary Examination Module ***********************************************************
  doctorid: number;
  visitid: number;
  billStatus: string;
  billingAmount: number;
  paidAmount: number;
  reportingTime: any;
  returnTime: any;
  visitType: string;
  public examid: number;
  public visitDate: any;
  add_presentingcomplaints: PresentingComplaintsModel = {};
  add_io: IntraocularPressureModel = {};

  presentingcomplaints: PresentingComplaintsModel[] = [
    // {complaint: "ABC", duration: "5", unit: "ABC", site: "LEFT"},
    // {complaint: "ABC", duration: "10", unit: "ABC", site: "LEFT"},
    // {complaint: "ABC", duration: "20", unit: "ABC", site: "LEFT"}
  ]

  intraocularpressure: IntraocularPressureModel[] = [
    //   {Method: "NCT", Time: "12:43PM", OdMethod: "12", OsMethod: "56", Pachy: "Yes",OdPachy: "0",  OsPachy: "0", Remarks: "TESTING REMARKS",
    // },
    //   {Method: "NCT", Time: "12:43PM", OdMethod: "12", OsMethod: "56", Pachy: "Yes",OdPachy: "0",  OsPachy: "0", Remarks: "TESTING REMARKS",

    // }
  ]
  add_OptoTestDetails: OptoTestDetail = {};
  optoTestDetails: OptoTestDetail[] = []
  optoInvDetails: InvestigationModel[] = []
  students_opto_list: StudentOptoModel[] = [];
  students_opto: StudentOptoModel = {};
  webMenuPermission: WebmenupermissionModel[] = [];

  historyStatusresult: any;
  clsactive: string;
  public pExamStatus: any = [];;
  public pExamStatusChk: pExamStatusModel = {};
  pxclsactive: string;
  public drclassactive: string = 'pending';
  chkvalue(value: string) {
    if (value != null) {
      return value;
    }
    else {
      return "?";
    }
  }
  // private AddNearValue = new BehaviorSubject<any>({
  //   boxValue: 'Add'
  // });
  // getAddNearValue() {
  //   return this.AddNearValue.asObservable();
  // }
  // setAddNearValue(user: any) {
  //   this.AddNearValue.next(user);
  // }
  //  getsphvalue(category: string, valuebox: string) {
  //   this.ar_value_box = valuebox;
  //   this.eyechkcategory = category;
  //   const dialogRef = this.dialog.open(EyecheckComponent, {

  //    // panelClass: 'full-width-dialog',

  //     height: '80%',
  //     width: '30%',
  //     data: {
  //        //category: category,
  //       //userid: this.authService.Loggeduser.userid
  //     }

  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     //  console.log('The dialog was closed');
  //     //pid = result;
  //    // this.surgicalhistory_ds = new MatTableDataSource(this.emrservice.surgicalhistory.slice());

  //   });
  // }
  notifyComponents() {
    this.componentClicked.next();
  }
  empty_list_arrays() {
    this.intraocularpressure = [];
    this.presentingcomplaints = [];
  }


  get_student_opto_data(transid: number) {
    return this.http.get(this.dashboardService.newbaseUrl + "OptoExamination/GetAddVisionRefDataByTranId/" + transid)
  }

  delete_complaint_PE(data: any) {
    return this.http.post(this.dashboardService.newbaseUrl + "OpdComplaintsDetail/Delete", data);
  }

  delete_iop_PE(payload) {
    return this.http.post(this.dashboardService.newbaseUrl + "IopDetail/InsertIopDetail", payload)
    // return this.http.delete(this.dashboardService.newbaseUrl + "IopDetail/Delete/" + Transid)
  }

  get_complaints_PE() {
    return this.http.get(this.dashboardService.newbaseUrl + "OpdComplaintsDetail/GetComplaints/" + this.opdvisitService.visitid + '/' + this.opdvisitService.patientdetails.pkRegId)

  }
  get_iop_list_PE() {
    return this.http.get(this.dashboardService.newbaseUrl + "IopDetail/Iop/" + this.opdvisitService.visitid)
  }

  get_student_opto_list() {
    return this.http.get(this.dashboardService.newbaseUrl + "OptoExamination/GetAddVisionRefDataByVisitId/" + this.opdvisitService.visitid)
  }
  savecomplaints_on_server(onlynewrecords) {
    // let onlynewrecords = this.presentingcomplaints.filter(record => record.pkComplaintId == null);
    return this.http.post(this.dashboardService.newbaseUrl + "OpdComplaintsDetail/InsertComplaints", onlynewrecords)
  }

  saveiop_on_server(payload) {

    return this.http.post(this.dashboardService.newbaseUrl + "IopDetail/InsertIopDetail", payload)
  }


  save_or_update_ar(type, typecheck) {
    this.autoref.HeadName = type;
    this.autoref.fkVisitId = this.visitid;
    if (type == 'DLAR' || type == 'UDAR') {
      if (this.pExamStatusChk?.autoRefractionDetails == 1) {
        if (this.autorefkeroPermission.isModifyPermission == true) {
          this.updateAutoref(type, typecheck);
        } else {
          return this.dashboardService.openSnackBar("Modify Permission Denied", "OK");
        }
      } else {
        if (this.autorefkeroPermission.isAddPermission == true) {
          this.saveautoref(type, typecheck);
        } else {
          return this.dashboardService.openSnackBar("Add Permission Denied", "OK");
        }
      }
    } else if (type == 'POG') {
      if (this.pExamStatusChk?.oldGlass == 1) {
        if (this.oldGlassPermission.isModifyPermission == true) {
          this.updateAutoref(type, typecheck);
        } else {
          return this.dashboardService.openSnackBar("Modify Permission Denied", "OK");
        }
      } else {
        if (this.oldGlassPermission.isAddPermission == true) {
          this.saveautoref(type, typecheck);
        } else {
          return this.dashboardService.openSnackBar("Add Permission Denied", "OK");
        }
      }
    }

  }
  saveautoref(type, typecheck) {
    this.autoref.pkTranId = this.autoref.pkTranId ? this.autoref.pkTranId : 0;
    this.autoref.isEdit = this.autoref.pkTranId ? true : false;
    this.autoref.isDelete = false;
    this.autoref.isActive = true;
    this.autoref.fkCreatedById = this.authService.Loggeduser.userid;
    this.autoref.createdDate = this.datePipe.transform(this.authService.localDate, "MM-dd-yyyy");
    this.http.post(this.dashboardService.newbaseUrl + "AutoRef/InsertAutoRef", this.autoref).subscribe(
      data => this.success_ar_save(data, type, typecheck), err => this.failed_ar_save(err)
    )
  }
  updateAutoref(type, typecheck) {
    this.autoref.isEdit = true;
    this.autoref.isDelete = false;
    this.autoref.isActive = true;
    this.autoref.fkModifiedById = this.authService.Loggeduser.userid;
    this.autoref.modifiedDate = this.datePipe.transform(this.authService.localDate, "MM-dd-yyyy");
    this.http.post(this.dashboardService.newbaseUrl + "AutoRef/InsertAutoRef", this.autoref).subscribe(
      data => this.success_ar_update(data, type, typecheck), err => this.failed_ar_update(err)
    )
  }
  success_ar_update(data, type, typecheck) {
    if (typecheck == 1) {
      this.enabledisableautorefkr = true;
    } else if (typecheck == 2) {
      this.enabledisableautorefkr1 = true;
    }
    if (type == 'POG') {
      this.enabledisablepog = true;
    }
    this.getPExamStatus();
    if (data.pkTranId > 0) {
      const currrentdate = JSON.parse(sessionStorage.getItem('SessiondateTime'));
      let payload = {
        "OpdTracking": {
          "StartTime": moment(this.holdtimeAutoref).format("HH:mm:ss"),
          "FinishTime": moment(currrentdate).format("HH:mm:ss"),
          "LocationId": 4,
          "VisitId": this.opdvisitService.visitid,
          "UserId": this.authService.Loggeduser.userid,
          "Remarks": "Modify AR Workup",
          "Type": "AR",
          "Total": 0,
          "UpdateTotal": true,
          "OnlyEntry": false,
          "UpdateLocationId": false,
          "SelectedUserId": 0,
          "IsEdit": true

        }

      }
      this.InsertOpdTracking(payload).subscribe(x => {

      })
    }
    this.dashboardService.openSnackBar("Record Updated Successfully", "OK");
  }

  failed_ar_update(err) {
    this.dashboardService.openSnackBar("Record Update Api Failed", "OK");
  }

  success_ar_save(data, type, typecheck) {
    if (typecheck == 1) {
      this.enabledisableautorefkr = true;
    } else if (typecheck == 2) {
      this.enabledisableautorefkr1 = true;
    }
    if (type == 'POG') {
      this.enabledisablepog = true;
    }
    this.getPExamStatus();
    const arrow = data;
    this.autoref.pkTranId = arrow.pkTranId;
    if (this.autoref.pkTranId > 0) {
      const currrentdate = JSON.parse(sessionStorage.getItem('SessiondateTime'));
      let payload = {
        "OpdTracking": {
          "StartTime": moment(currrentdate).format("hh:mm:ss"),
          "FinishTime": moment(new Date).format("hh:mm:ss"),
          "LocationId": 4,
          "VisitId": this.opdvisitService.visitid,
          "UserId": this.authService.Loggeduser.userid,
          "Remarks": "AR Workup",
          "Type": "AR",
          "Total": 0,
          "UpdateTotal": true,
          "OnlyEntry": false,
          "UpdateLocationId": false,
          "SelectedUserId": 0,
          "IsEdit": false
        }


      }
      this.InsertOpdTracking(payload).subscribe(x => {

      })
    }
    this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
    //this.emrservice.autoref = {};
  }
  failed_ar_save(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
    // this.dashboardService.openSnackBar("Record Api Insert Failed", "OK")
  }

  success_opto_update(data, type) {
    // this.getoptdata();
    if (type == 1) {
      this.enabledisableVision = true;
    } else if (type == 2) {
      this.enabledisableUd = true;
    } else if (type == 3) {
      this.enabledisableGP = true;
    } else if (type == 4) {
      this.enabledisableopt = true;
    }
    if (data.pkOptId > 0) {
      const currrentdate = JSON.parse(sessionStorage.getItem('SessiondateTime'));
      let payload = {
        "OpdTracking": {
          "StartTime": moment(this.holdtimeopto).format("HH:mm:ss"),
          "FinishTime": moment(currrentdate).format("HH:mm:ss"),
          "LocationId": 5,
          "VisitId": this.opdvisitService.visitid,
          "UserId": this.authService.Loggeduser.userid,
          "Remarks": "Modify Opto Workup",
          "Type": "OP",
          "Total": 0,
          "UpdateTotal": true,
          "OnlyEntry": false,
          "UpdateLocationId": false,
          "SelectedUserId": 0,
          "IsEdit": true

        }

      }
      this.InsertOpdTracking(payload).subscribe(x => {

      })
    }
    this.dashboardService.openSnackBar("Record Updated Successfully", "OK");
    this.getPExamStatus();
  }

  failed_opto_update(err) {
    // this.dashboardService.openSnackBar("Record Update Api Failed", "OK");
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  success_opto_save(data, type) {
    // this.getoptdata();
    if (type == 1) {
      this.enabledisableVision = true;
    } else if (type == 2) {
      this.enabledisableUd = true;
    } else if (type == 3) {
      this.enabledisableGP = true;
    } else if (type == 3) {
      this.enabledisableopt = true;
    }
    const visit = data;
    this.opto.pkOptId = visit.pkOptId;
    if (this.opto.pkOptId > 0) {
      const currrentdate = JSON.parse(sessionStorage.getItem('SessiondateTime'));
      let payload = {
        "OpdTracking": {
          "StartTime": moment(this.holdtimeopto).format("hh:mm:ss"),
          "FinishTime": moment(currrentdate).format("hh:mm:ss"),
          "LocationId": 5,
          "VisitId": this.opdvisitService.visitid,
          "UserId": this.authService.Loggeduser.userid,
          "Remarks": "Opto Workup",
          "Type": "OP",
          "Total": 0,
          "UpdateTotal": true,
          "OnlyEntry": false,
          "UpdateLocationId": false,
          "SelectedUserId": 0,
          "IsEdit": false

        }

      }
      this.InsertOpdTracking(payload).subscribe(x => {

      })

    }
    this.getPExamStatus();
    this.dashboardService.openSnackBar("Record Saved Successfully", "OK");

  }
  getoptdata() {
    this.get_opto_data().subscribe((item: any) => {
      if (item != null) {
        this.opto = item;
      } else {
        this.opto = {};
      }
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      }
      else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }
  failed_opto_save(err) {
    // this.dashboardService.openSnackBar("Record Api Insert Failed", "OK")
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  save_student_opto_on_server() {

    this.students_opto.fkVisitId = this.visitid;

    if (this.students_opto.dvwithGlassOs == null) {
      this.students_opto.dvwithGlassOs = "";
    }
    this.students_opto.entryDateTime = this.datePipe.transform(JSON.parse(sessionStorage.getItem('SessiondateTime')), "MM-dd-yyyy HH:mm");
    //this.students_opto.entryDateTime = new Date().toString();
    // check new or update 
    if (this.students_opto.pkTranId != null) {
      // update record
      this.students_opto.IsDelete = false;
      this.students_opto.IsEdit = true;
      this.students_opto.userIdmodify = this.authService.Loggeduser.userid;
      let payload = {
        OptoAdditionalVisionRefraction: this.students_opto
      }
      this.http.post(this.dashboardService.newbaseUrl + "OptoExamination/InsertAddVisionData", payload).subscribe(
        data => this.success_student_opto_update(data), err => this.failed_student_opto_update(err)
      )
    }
    else {
      // save new record
      console.log("visit id " + this.students_opto.fkVisitId);
      this.students_opto.IsDelete = false;
      this.students_opto.IsEdit = false;
      this.students_opto.pkTranId = 0;
      this.students_opto.userIdadd = this.authService.Loggeduser.userid;
      let payload = {
        OptoAdditionalVisionRefraction: this.students_opto
      }
      this.http.post(this.dashboardService.newbaseUrl + "OptoExamination/InsertAddVisionData", payload).subscribe(
        data => this.success_student_opto_save(data), err => this.failed_student_opto_save(err)
      )
    }

    //return this.http.post(this.dashboardService.baseUrl + "OptoExamination/InsertOPData", this.opto);
  }

  success_student_opto_save(data) {
    // this.get_student_opto_list().subscribe(
    //   data => this.success_student_opto_list(data), err => this.failed_student_opto_list(err)
    // )
    this.get_student_opto_lists();
    this.getPExamStatus();
    this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
  }


  success_student_opto_list(data) {
    this.students_opto_list = data;
    //this.getapicount();
  }

  failed_student_opto_list(err) {
    // this.getapicount();

  }
  getstudentdata(transid: number) {
    this.get_student_opto_data(transid).subscribe(
      data => this.success_student_data(data), err => this.failed_student_data(err)
    )
  }

  get_student_opto_lists() {
    let getDatalist: any
    this.dashboardService.subscriptions = this.get_student_opto_list().subscribe(data => {
      getDatalist = data;
      if (getDatalist.length != 0) {
        this.students_opto_list = getDatalist;
        this.getstudentdata(getDatalist[0]?.pkTranId);
      }
    })
  }

  success_student_data(data) {
    let studentdata = data;
    if (studentdata.length != 0) {
      this.students_opto = data[0];
    }
  }

  failed_student_data(err) {

  }
  failed_student_opto_save(err) {
    // this.dashboardService.openSnackBar("Record Api Insert Failed", "OK");
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  success_student_opto_update(data) {
    // this.get_student_opto_list().subscribe(
    //   data => this.success_student_opto_list(data), err => this.failed_student_opto_list(err)
    // )
    this.get_student_opto_lists();
    this.getPExamStatus();
    this.dashboardService.openSnackBar("Record Updated Successfully", "OK");
  }
  failed_student_opto_update(err) {
    // this.dashboardService.openSnackBar("Record Update Api Failed", "OK");
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  save_opto_on_server(type) {
    this.opto.fkVisitId = this.visitid;

    if (this.opto.pkOptId != 0) {

      if (type == 1) {
        this.opto.HeadName = 'OPTOVISION';
        if (this.visionPermission.isModifyPermission != true) {
          return this.dashboardService.openSnackBar("Modify Permission Denied", "ok");
        }
      } else if (type == 2) {
        if ((this.opto.udrc1 != null && this.opto.udrc1 != "") && (this.opto.udrs1 == null || this.opto.udrs1 == "") && (this.opto.udra1 == null || this.opto.udra1 == "")) {

          return this.dashboardService.openSnackBar("Please Mention Axis in Case of Cyl is there in Right Eye Please Mention Sph in Case of Cyl or Axis is there in Right Eye, Please Enter Sph in number Format not (Plano) ", "ok");
        } else if ((this.opto.udrc1 != null && this.opto.udrc1 != "") && (this.opto.udrs1 == null || this.opto.udrs1 == "") && (this.opto.udra1 != null && this.opto.udra1 != "")) {
          return this.dashboardService.openSnackBar("Please Mention Sph in Case of Cyl or Axis is there in Right Eye, Please Enter Sph in number Format not (Plano) ", "ok");
        } else if ((this.opto.udrc1 != null && this.opto.udrc1 != "") && (this.opto.udrs1 != null && this.opto.udrs1 != "") && (this.opto.udra1 == null || this.opto.udra1 == "")) {
          return this.dashboardService.openSnackBar("Please Mention Axis in Case of Cyl is there in Right Eye", "ok");
        } else if ((this.opto.udrc1 == null || this.opto.udrc1 == "") && (this.opto.udrs1 == null || this.opto.udrs1 == "") && (this.opto.udra1 != null && this.opto.udra1 != "")) {
          return this.dashboardService.openSnackBar("Please Mention Sph in Case of Cyl or Axis is there in Right Eye, Please Enter Sph in Number Format Not(Plano) ", "ok");
        } else if ((this.opto.udlc1 != null && this.opto.udlc1 != "") && (this.opto.udls1 == null || this.opto.udls1 == "") && (this.opto.udla1 == null || this.opto.udla1 == "")) {
          return this.dashboardService.openSnackBar("Please Mention Axis in Case of Cyl is there in Left Eye Please Mention Sph in Case of Cyl or Axis is there in Left Eye, Please Enter Sph in number Format not (Plano) ", "ok");
        } else if ((this.opto.udlc1 != null && this.opto.udlc1 != "") && (this.opto.udls1 == null || this.opto.udls1 == "") && (this.opto.udla1 != null && this.opto.udla1 != "")) {
          return this.dashboardService.openSnackBar("Please Mention Sph in Case of Cyl or Axis is there in Light Eye, Please Enter Sph in number Format not (Plano) ", "ok");
        } else if ((this.opto.udlc1 != null && this.opto.udlc1 != "") && (this.opto.udls1 != null && this.opto.udls1 != "") && (this.opto.udla1 == null || this.opto.udla1 == "")) {
          return this.dashboardService.openSnackBar("Please Mention Axis in Case of Cyl is there in Left Eye", "ok");
        } else if ((this.opto.udlc1 == null || this.opto.udlc1 == "") && (this.opto.udls1 == null || this.opto.udls1 == "") && (this.opto.udla1 != null && this.opto.udla1 != "")) {
          return this.dashboardService.openSnackBar("Please Mention Sph in Case of Cyl or Axis is there in Left Eye, Please Enter Sph in Number Format Not(Plano) ", "ok");
        }
        this.opto.HeadName = 'OPTOUD';
        if (this.unDilatedAndDilatedPermission.isModifyPermission != true) {
          return this.dashboardService.openSnackBar("Modify Permission Denied", "ok");
        }
      } else if (type == 3) {
        if (this.opto.gprcd != null && this.opto.gprcd != "" && this.opto.gprad == null || this.opto.gprad == "") {
          return this.dashboardService.openSnackBar("Please Mention Axis in Case of Cyl is there in Right Eye", "ok");
        }
        if (this.opto.gplcd != null && this.opto.gplcd != "" && this.opto.gplad == null || this.opto.gplad == "") {
          return this.dashboardService.openSnackBar("Please Mention Axis in Case of Cyl is there in Left Eye", "ok");
        }

        this.opto.HeadName = 'OPTOGP';
        if (this.glassPrescriptionPermission.isModifyPermission != true) {
          return this.dashboardService.openSnackBar("Modify Permission Denied", "ok");
        }
      } else if (type == 4) {
        this.opto.HeadName = 'OPTOPOI';
        if (this.postOpInformationPermission.isModifyPermission != true) {
          return this.dashboardService.openSnackBar("Modify Permission Denied", "ok");
        }
      }
      this.opto.IsEdit = true;
      this.opto.IsDelete = false;
      this.opto.fkModifyById = this.authService.Loggeduser.userid;

      let payload = {
        OpdOptoExamination: this.opto
      }
      this.http.post(this.dashboardService.newbaseUrl + "OptoExamination/InsertOPData", payload).subscribe(
        data => this.success_opto_update(data, type), err => this.failed_opto_update(err)
      )
    }
    else {
      if (type == 1) {
        this.opto.HeadName = 'OPTOVISION';
        if (this.visionPermission.isAddPermission != true) {
          return this.dashboardService.openSnackBar("Add Permission Denied", "ok");
        }
      } else if (type == 2) {
        this.opto.HeadName = 'OPTOUD';
        if (this.unDilatedAndDilatedPermission.isAddPermission != true) {
          return this.dashboardService.openSnackBar("Add Permission Denied", "ok");
        }
      } else if (type == 3) {
        if (this.opto.gprcd != null && this.opto.gprcd != "" && this.opto.gprad == null || this.opto.gprad == "") {
          return this.dashboardService.openSnackBar("Please Mention Axis in Case of Cyl is there in Right Eye", "ok");
        }
        if (this.opto.gplcd != null && this.opto.gplcd != "" && this.opto.gplad == null || this.opto.gplad == "") {
          return this.dashboardService.openSnackBar("Please Mention Axis in Case of Cyl is there in Left Eye", "ok");
        }
        this.opto.HeadName = 'OPTOGP';
        if (this.glassPrescriptionPermission.isAddPermission != true) {
          return this.dashboardService.openSnackBar("Add Permission Denied", "ok");
        }
      } else if (type == 4) {
        this.opto.HeadName = 'OPTOPOI';
        if (this.postOpInformationPermission.isAddPermission != true) {
          return this.dashboardService.openSnackBar("Add Permission Denied", "ok");
        }
      }

      this.opto.pkOptId = 0;
      this.opto.IsDelete = false;
      this.opto.IsEdit = false;
      this.opto.fkCreatedById = this.authService.Loggeduser.userid;
      let payload = {
        OpdOptoExamination: this.opto
      }
      this.http.post(this.dashboardService.newbaseUrl + "OptoExamination/InsertOPData", payload).subscribe(
        data => this.success_opto_save(data, type), err => this.failed_opto_save(err)
      )
    }

    //return this.http.post(this.dashboardService.baseUrl + "OptoExamination/InsertOPData", this.opto);
  }

  // update_opto_on_server(){
  //   return this.http.post(this.dashboardService.baseUrl + "OptoExamination/UpdateOPData", this.opto);
  // }


  delete_ar_data() {

    if (this.autoref.pkTranId != null) {
      this.autoref.isEdit = true;
      this.autoref.isDelete = true;
      this.autoref.isActive = false;
      this.http.post(this.dashboardService.newbaseUrl + "AutoRef/Delete/", this.autoref).subscribe(
        data => this.success_ar_delete(data), err => this.failed_ar_delete(err)
      )
    }

  }
  success_ar_delete(data) {
    this.dashboardService.openSnackBar("AR Data deleted successfully", "OK");
    this.autoref = {};
  }

  failed_ar_delete(err) {
    // this.dashboardService.openSnackBar("AR Data delete api failed", "OK");
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }



  delete_optodata() {

    if (this.opto.pkOptId != null) {
      this.http.get(this.dashboardService.newbaseUrl + "OptoExamination/Delete/" + this.opto.pkOptId).subscribe(
        data => this.success_opto_delete(data), err => this.failed_opto_delete(err)
      )
    }

  }
  success_opto_delete(data) {
    this.dashboardService.openSnackBar("Opto Data deleted successfully", "OK");
    this.opto = {};
  }

  failed_opto_delete(err) {
    // this.dashboardService.openSnackBar("Opto Data delete api failed", "OK");
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }



  get_ar_data() {
    // AutoRef/GetARdata/visitId
    return this.http.get(this.dashboardService.newbaseUrl + "AutoRef/GetARdata/" + this.visitid)
  }

  // get_opto_data() {
  //   // AutoRef/GetARdata/851519
  //   return this.http.get(this.dashboardService.newbaseUrl + "OptoExamination/GetOPdata/" + this.visitid)
  // }
  get_opto_data() {
    // AutoRef/GetARdata/851519
    return this.http.get(this.dashboardService.newbaseUrl + "OptoExamination/GetOptoByVisitId/" + this.visitid)
  }
  // Primary Examination Module Ends ********************************************************



  //Doctor Modules ******************************************************************

  surgery: SurgeryModel[] = [
    { surgeryName: "", remarks: "", surgenName: "" },

  ]


  medicines: MedicineModal[] = [
    { medicineName: "", qty: null, dosageCode: "", days: "", unit: "", remarks: "", medicineType: "" },

  ]

  diagnosis: DiagnosisModel[] = [
    { icdcode: "", diagnosisName: "", remarks: "", isEdit: false },

  ]

  investigations: InvestigationModel[] = [
    { serviceName: "", Comments: "", Site: "", DisCount: "", Academic: false },

  ]

  findings: FindingsModel[] = [
    { findingName: "", examValues1: "", examValues2: "", BE: "" },


  ]

  //Doctor Modules Ends *************************************************************


  constructor(private http: HttpClient,
    private dashboardService: DashboardService,
    private opdvisitService: OpdVisitService, private datePipe: DatePipe,
    private dialog: MatDialog, private authService: AuthService) { }


  // primary examination methods


  // primary examination methods ends

  save_other_info_history() {

    this.set_defaultvalues_otherinfo_history();
    //this.chkvalues();
    if (this.otherinfo_history.pkTranId != 0) {
      this.otherinfo_history.fkRegId = this.opdvisitService.patientdetails.pkRegId;
      this.otherinfo_history.fK_ModifiedByID = this.authService.Loggeduser.userid;
      this.otherinfo_history.createdDateTime = null;
      if (this.otherinfo_history.fkRegId != 0) {
        return this.http.post(this.dashboardService.newbaseUrl + "HistoryGeneral/InsertHistoryGeneral",
          this.otherinfo_history)
      } else {
        this.dashboardService.openSnackBar("Please Select Patient", "OK");
      }
    } else {
      this.otherinfo_history.fkRegId = this.opdvisitService.patientdetails.pkRegId;
      this.otherinfo_history.fK_CreatedByID = this.authService.Loggeduser.userid;
      this.otherinfo_history.createdDateTime = null;
      if (this.otherinfo_history.fkRegId != 0) {
        return this.http.post(this.dashboardService.newbaseUrl + "HistoryGeneral/InsertHistoryGeneral",
          this.otherinfo_history)
      } else {
        this.dashboardService.openSnackBar("Please Select Patient", "OK");
      }
    }
  }
  chkvalues() {

    console.log(


      // 0  17 sdgssgs  sdgsdg  sgsg  true  null  sdgsgd  true  dsgdsg  sdgsdgs  sdgsdg  null  

      //  "transid " + this.otherinfo_history. pkTranId + "  " +
      // " fkRegId " + this.otherinfo_history.fkRegId +
      // " advReactionHistory " +this.otherinfo_history.advReactionHistory + "  " +
      // "pastEyeHistory" +this.otherinfo_history.pastEyeHistory + "  " +
      // " birthHistory " +this.otherinfo_history.birthHistory + "  " +
      // " isBiohazard " +this.otherinfo_history.isBiohazard + "  " +
      // " pkSynchId " +this.otherinfo_history.pkSynchId + "  " +
      // " remarks " +this.otherinfo_history.remarks + "  " +
      // " isOneEyed " +this.otherinfo_history.isOneEyed + "  " + 
      // " bioHazardDetail " +this.otherinfo_history.bioHazardDetail + "  " +
      // " specialremarks " +this.otherinfo_history.specialremarks  + "  " +
      // " riskScore " +this.otherinfo_history.riskScore + "  " 
      // "fkReg " +this.otherinfo_history.fkReg + "  " 

    )
  }

  // [{"pkTranId":0,"fkRegId":3315,"advReactionHistory":"fsdssfs",
  // "pastEyeHistory":"sdfssfs","birthHistory":"sdfsdfds",
  // "isBiohazard":true,"pkSynchId":null,"remarks":"sdfsfs sf sfsd ",
  // "isOneEyed":true,"bioHazardDetail":"sdfsfs sdfs","specialremarks":" sdfsfsdfs fs",
  // "riskScore":5,"fkReg":null}]

  set_defaultvalues_otherinfo_history() {

    // this.otherinfo_history.advReactionHistory = "fsdssfs";
    //this.otherinfo_history.pastEyeHistory = "sdfssfs";
    //this.otherinfo_history.birthHistory = "sdfsdfds";
    //this.otherinfo_history.isBiohazard="true";
    this.otherinfo_history.pkSynchId = null;
    // this.otherinfo_history.remarks="sdfsfs sf sfsd ";
    //this.otherinfo_history.isOneEyed="true";
    //this.otherinfo_history.bioHazardDetail="sdfsfs sdfs";
    //this.otherinfo_history.specialremarks="sdfsfsdfs fs";
    //this.otherinfo_history.riskScore= 5;
    this.otherinfo_history.fkReg = null;


    this.otherinfo_history.fkRegId = this.opdvisitService.patientdetails.pkRegId;
    // this.otherinfo_history.pkTranId = 0

  }
  getdoctor_survey() {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "DiabetesSurvey/" +
      this.opdvisitService.patientdetails.pkRegId)
  }


  save_diabetic_survey() {
    this.setdefault_values();

    return this.http.post(this.dashboardService.newbaseUrl + "DiabetesSurvey/InsertDiabetesSurvey",
      this.diabetic_survey)
  }

  setdefault_values() {
    this.diabetic_survey.fkRegId = this.opdvisitService.patientdetails.pkRegId;
    this.diabetic_survey.pkTranId = 0
  }



  open_loader_Dialog(): void {

    const dialogRef = this.dialog.open(SiteloaderComponent, {
      width: '300px',
      panelClass: 'site-loader',
      data: {
        // id: this.dashboardService.pid,
        //userid: this.authService.Loggeduser.userid
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      //pid = result;
    });
  }













  // past history apis

  get_pasthistory(visitid: any) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "HistoryDisease/" +
      this.opdvisitService.patientdetails.pkRegId + '/' + visitid)
  }

  save_pasthistory_to_server(pasthistory) {
    return this.http.post(this.dashboardService.newbaseUrl + "HistoryDisease/InsertHistoryDisease", pasthistory)

  }


  delete_pasthistory_on_server(disid: number) {
    return this.http.get(this.dashboardService.newbaseUrl + "HistoryDisease/Delete/" +
      disid);
  }

  // surgery apis

  get_surgeries(visitid: any) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "HistorySurgical/" +
      this.opdvisitService.patientdetails.pkRegId + '/' + visitid)
  }

  save_surgeries_to_server() {
    //HistoryDisease/InsertHistorySurgical
    return this.http.post(this.dashboardService.newbaseUrl + "HistorySurgical/InsertHistorySurgical",
      this.surgicalhistory_client)

  }
  save_surgeries(data) {
    //HistoryDisease/InsertHistorySurgical
    return this.http.post(this.dashboardService.newbaseUrl + "HistorySurgical/InsertHistorySurgical", data)

  }

  delete_surgery_on_server(surid: number) {
    return this.http.get(this.dashboardService.newbaseUrl + "HistorySurgical/Delete/" +
      surid);
  }

  //family history apis

  get_familyhistory() {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "HistoryFamily/" +
      this.opdvisitService.patientdetails.pkRegId)
  }

  save_familyhistory_to_server(filterfamilyhistory) {

    // const filterfamilyhistory = this.familyhistory.filter(item => item.pkTranId == 0);

    return this.http.post(this.dashboardService.newbaseUrl + "HistoryFamily/InsertHistoryFamily", filterfamilyhistory)

  }

  delete_familyhistory_on_server(disid: number) {
    return this.http.get(this.dashboardService.newbaseUrl + "HistoryFamily/Delete/" +
      disid);
  }

  // salts apis

  get_allergies() {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "HistoryDrugAllergy/" +
      this.opdvisitService.patientdetails.pkRegId)
  }

  get_otherinfo() {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "HistoryGeneral/" +
      this.opdvisitService.patientdetails.pkRegId)
  }


  save_allergies_to_server(filterdrughistory) {

    // console.log(this.drugallergy[0].pKTranId, + "  ", 
    // this.drugallergy[0].FKSaltId, + " " + this.drugallergy[0].FKRegId +
    //  " " +this.drugallergy[0].saltName)

    // const filterdrughistory = this.drugallergy.filter(item => item.pKTranId == 0);

    // for (let a of filterdrughistory) {
    //   console.log("saltid " + a.FKSaltId);
    //   console.log("saltname " + a.saltName);
    //   console.log("salttransid " + a.pKTranId);
    //   console.log("fkregid " + a.FKRegId);
    // }


    return this.http.post(this.dashboardService.newbaseUrl + "HistoryDrugAllergy/InsertDrugAllergy", filterdrughistory)

  }





  delete_allergy_on_server(drugid: number) {
    return this.http.get(this.dashboardService.newbaseUrl + "HistoryDrugAllergy/Delete/" +
      drugid);
  }

  // insert old summery 

  insertOldSummery(inserdata: any) {
    return this.http.post(this.dashboardService.newbaseUrl + "DoctorWorkUp/InsertPatientOldCaseSummary",
      inserdata)
  }

  //get old summery 
  GetOldSummery(pid) {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUp/GetPatientOldCaseSummaryByRegId/" + pid)
  }
  //get doctor template API
  GetdoctorTemplate(id) {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/GetTemplate/" + id)

  }
  //get doctor template API
  GetMedicineTemplate(Pk_TempPresDetailId: any, Fk_TemplateId: any) {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/GetTemplatePrescriptionDetailByIdByTemplateId/" + Pk_TempPresDetailId + '/' + Fk_TemplateId)

  }
  //get examination api
  GetExaminationdata(Pk_TempPresDetailId: any, Fk_TemplateId: any) {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/GetTemplateExaminationDetailByIdByTemplateId/" + Pk_TempPresDetailId + '/' + Fk_TemplateId)
  }
  //get Diagnosis api
  GetDiagnosisdata(Pk_TempPresDetailId: any, Fk_TemplateId: any) {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/GetTemplateDiagnosisDetailByIdByTemplateId/" + Pk_TempPresDetailId + '/' + Fk_TemplateId)
  }
  //get Surgery api
  GetSurgerydata(Pk_TempPresDetailId: any, Fk_TemplateId: any) {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/GetTemplateSurgeryByIdByTemplateId/" + Pk_TempPresDetailId + '/' + Fk_TemplateId)
  }
  //get Surgery api
  GetInvestigationdata(Pk_TempPresDetailId: any, Fk_TemplateId: any) {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/GetTemplateInvestigationDetailByIdByTemplateId/" + Pk_TempPresDetailId + '/' + Fk_TemplateId)
  }
  getFIndingmainAPI(pk_GroupId) {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/GetFindingGroup/" + pk_GroupId)
  }
  SaveFIndingmainAPI(payload: any) {
    return this.http.post(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/InsertFindingGroupMaster",
      payload);
  }
  InsertFindingMaster(payload) {
    return this.http.post(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/InsertFindingMaster",
      payload);
  }

  InsertFindingSubGroupMaster(payload: any) {
    return this.http.post(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/InsertFindingSubGroupMaster",
      payload);
  }
  InsertFindingResult(payload: any) {
    return this.http.post(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/InsertFindingResult",
      payload);
  }

  GetFindingSubGroup(fk_GroupId: any) {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/GetFindingSubGroup/" + fk_GroupId)
  }
  GetFindingGroupdata(fK_SubGroupId: any, type, searchtype) {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/GetFinding/" + fK_SubGroupId + '/' + type + '/' + searchtype)
  }
  GetFindingGResult(pk_FindingId: any, type, searchtype) {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/GetFindingResult/" + pk_FindingId + '/' + type + '/' + searchtype)
  }

  //insert template data 
  InsertTemplate(payload: any) {
    return this.http.post(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/InsertTemplate",
      payload);
  }
  GetFindingGResultByregid(regid: any, visitid, docid) {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUp/GetOPDDrExaminationByRegId/" + regid + '/' + visitid + '/' + docid)
  }
  GetFindingGResultByregidd(regid: any, visitid, docid, type) {

    this.dashboardService.subscriptions = this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUp/GetOPDDrExaminationByRegId/" + regid + '/' + visitid + '/' + docid).subscribe(
      data => this.success_opto_finding(data, type), err => this.failed_opto_finding(err)
    )

  }
  success_opto_finding(data, type) {

    this.opdvisitService.patientDrdetaill = [];
    if (data.length > 0) {
      this.opdvisitService.patientDrdetaill = data.filter(item => item.pK_ExamId == this.examid);
      if (this.opdvisitService.patientDrdetaill.length == 0) {
        this.examdataNotavailable();
      }

    } else {
      this.examdataNotavailable();
    }

    if (type == 0) {
      this.content.next('2');
    } else if (type == 1) {
      this.content.next('22');
    }

  }
  // getReviewData(regid: any) {
  //   return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUp/GetOPDDrExaminationByRegId/" + regid)
  // }
  examdataNotavailable() {
    this.opdvisitService.patientDrdetaill = [];
    this.opdvisitService.patientDrdetaill.push({
      pK_ExamId: null, fK_VisitId: null, fK_DoctorId: null, nextReview: null,
      nextReviewUnit: null, nextReviewDate: null, isReferredTo: false,
      referralReason: null,
      isUnderGVP: false,
      isAdviced: false,
      drRemarks: null,
      nextVisitPlan: null,
      prognosis: null,
      nutritionalAdvice: null,
      examinationComments: null,
      diagnosisComments: null,
      isDrugSide: false,
      isInvSide: false,
      isSurgRisk: false,
      fK_ConsId: 0,
      pK_SynchId: null,
      oldExamID: 0,
      olddrname: null,
      oldvisitdate: null,
      regionalRemarks: null,
      pG_Doctor: null,
      personalRemarks: null,
      remarksForCounselor: null,
      gvpType: null,
      drFristDateTimeWorkup: this.holdtimeDoctor ? moment(this.holdtimeDoctor).format("HH:mm:ss") : moment(JSON.parse(sessionStorage.getItem('SessiondateTime'))).format("HH:mm:ss"),
      drFristDateTimeWorkupFinish: null,
      pain_score: null,
      pain_Onset: null,
      pain_location: null,
      aggravating_with: null,
      characteristic: null,
      pain_duration: null,
      isFillByOpto: null,
      fK_OptoId: null,
      immunization: null,
      fallRisk: null,
      isNextReviewSmsSent: null,
      nextReviewNote: null,
      newRegionalRemarks: null,
      investigationRemarks: null,
      managmentRemarks: null,
      isSentSMS: null,
      isReviewSMS: null,
      isPopupMessage: null,
      tpEnd: null,
      keyword: null,
      otCheckDetail: null,
      requestToOtherDoctor: null,
      fK_RequestDoctorId: null,
      isSurgeryAdvised: null,
      fK_DoctorDeptID: null,
      isConverted: null,
      fK_Convert_OTID: null,
      isCrossedSeen: null,
      drName: null,
      requestDoctorName: null,
      // ageYear: null,
      // ageMonth: null,
      // ageDays: null,
      doctorName: null,
      visitDate: null,
      branchCode: null,
      imgRegId: null,
      proRegId: null,
      // isEdit: false
    })
  }
  failed_opto_finding(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  SaveDrwrokupData(payload: any) {
    return this.http.post(this.dashboardService.newbaseUrl + "DoctorWorkUp/InsertDrWorkupNew",
      payload);

  }
  GetFindingByRegId(RegId: any, visitid, docid) {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUp/GetFindingByRegId/" + RegId + '/' + visitid + '/' + docid);
  }
  GetDiagonisCategory(pk_DiagnosisCatId: any) {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/GetDiagnosisCategory/" + pk_DiagnosisCatId);
  }
  GetGetDiagnosis(pk_DiagnosisId: any, searchName, Searchtype) {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/GetDiagnosis/" + pk_DiagnosisId + '/' + searchName + '/' + Searchtype);
  }


  GetGetDiagnosismaster(diagonisiid: any, searchname: any, searchtype: any) {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/GetDiagnosisMaster/" + diagonisiid + '/' + searchname + '/' + searchtype);
  }
  GetSurgeryDetailByRegId(ByRegId, visitid, docid) {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUp/GetSurgeryDetailByRegId/" + ByRegId + '/' + visitid + '/' + docid);
  }
  GetInvestigationDetailByRegId(ByRegId, visitid, docid) {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUp/GetInvestigationDetailByRegId/" + ByRegId + '/' + visitid + '/' + docid);
  }
  GetDiagnosisFrequentByUserId(userid) {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/GetDiagnosisFrequentByUserId/" + userid);
  }
  getDaigonosisbyRegid(Regid, visitid, docid) {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUp/GetDiagnosisByRegId/" + Regid + '/' + visitid + '/' + docid);
  }

  GetPreSetting(branchid: any, userId: any, data: any) {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkupMaster/GetOpdPrescriptionSettingByBranchIdByUserIdByReportNameByColName/" + branchid + '/' + userId + '/' + data + '/ClEAR');
  }
  SavePreSettingData(payload: any) {
    return this.http.post(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/InsertOpdPrescriptionSetting",
      payload);
  }
  //medinice related api 

  GetMedicineCategoryMaster(mediid) {
    return this.http.get(this.dashboardService.newbaseUrl + "MedicineMaster/GetMedicineCategoryMaster/" + mediid);
  }
  GetMedicineMaster(pK_MedicineId, type, searchtype,categoryid) {
    return this.http.get(this.dashboardService.newbaseUrl + "MedicineMaster/GetMedicineMaster/" + pK_MedicineId + '/' + type + '/' + searchtype + '/' + this.authService.Loggeduser.branchid +'/'+categoryid);
  }

  GetMedicineMfgMaster(mfgid) {
    return this.http.get(this.dashboardService.newbaseUrl + "MedicineMaster/GetMedicineMfgMaster/" + mfgid);
  }
  GetDosageMaster(doseid, type, seachtype) {
    return this.http.get(this.dashboardService.newbaseUrl + "MedicineMaster/GetDosageMaster/" + doseid + '/' + type + '/' + seachtype);
  }

  /** AI Scribe: global service-name search (dept/category wildcarded) for FK resolution. */
  GetServiceByNameGlobal(serviceName, searchtype) {
    return this.http.get<any>(this.dashboardService.newbaseUrl +
      "RateList/GetRateListByRateListIdRateTypeIdByDeptNameByCategoryNameByServiceName/1/1/~/~/" +
      serviceName + '/' + searchtype);
  }
  InsertMedicineMaster(payload) {
    return this.http.post(this.dashboardService.newbaseUrl + "MedicineMaster/InsertMedicineMaster",
      payload);
  }
  //insert medicine category
  InsertMedicineCategoryMaster(payload) {
    return this.http.post(this.dashboardService.newbaseUrl + "MedicineMaster/InsertMedicineCategoryMaster",
      payload);
  }
  //insert mfg company 
  InsertMedicineMfgMaster(payload) {
    return this.http.post(this.dashboardService.newbaseUrl + "MedicineMaster/InsertMedicineMfgMaster",
      payload);
  }
  //cooman helplist dynamic pop up 
  GetPopUpHelpGeneral(parameter: any) {
    return this.http.get(this.dashboardService.newbaseUrl + "Common/GetPopUpHelpGeneral/" + parameter);
  }

  // insert Dynamic HelpList popup
  InsertDynamicHelpList(payload: any) {
    return this.http.post(this.dashboardService.newbaseUrl + "Common/InsertDynamicHelpList",
      payload);
  }

  GetPrescriptionDetailByRegId(regid, visitid, docid) {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUp/GetPrescriptionDetailByRegId/" + regid + '/' + visitid + '/' + docid);
  }

  getappoitmentType() {
    return this.http.get(this.dashboardService.newbaseUrl + "Appointment/GetAppointmentMaster");
  }

  getpredefindMessage() {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/GetCodeAbbreviation/0");
  }
  // Social History
  getSocialHistory() {
    return this.http.get(this.dashboardService.newbaseUrl + "Common/GetPopUpHelpGeneral/SocialHistory");
  }
  //add new diagonsis
  SaveDaigonsisData(payload: any) {
    return this.http.post(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/InsertDiagnosis",
      payload);
  }
  InsertDiagnosisCategoryMaster(payload: any) {
    return this.http.post(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/InsertDiagnosisCategoryMaster",
      payload);
  }
  InsertSurgeryMaster(payload) {
    return this.http.post(this.dashboardService.newbaseUrl + "SurgeryMaster/InsertSurgeryMaster",
      payload);
  }
  //get sugery master
  GetSurgeryAll(type, searchtype) {
    return this.http.get(this.dashboardService.newbaseUrl + "SurgeryMaster/GetSurgeryAll/" + type + '/' + searchtype);
  }
  //pop up GetPopUpHelp
  GetPopUpHelp(parameter) {
    return this.http.get(this.dashboardService.newbaseUrl + "Common/GetPopUpHelp/" + parameter);
  }

  getSpeciltiyData(specid) {
    return this.http.get(this.dashboardService.newbaseUrl + "Common/GetSubSpeciality/" + specid + '/' + this.authService.Loggeduser.specialityId);
  }
  //get route data
  getRouteMaster(routeid) {
    return this.http.get(this.dashboardService.newbaseUrl + "MedicineMaster/GetRouteMaster/" + routeid);
  }

  getoptomVisitdata(visitid) {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkup/GetOptoTransferOpdVisitFindingDetailByVisitId/" + visitid);
  }
  //insertpop data

  //getlanguage master

  GetLanguageMaster(lngid) {
    return this.http.get(this.dashboardService.newbaseUrl + "Common/GetLanguageMaster/" + lngid);
  }
  InsertHelplistpopup(payload) {
    return this.http.post(this.dashboardService.newbaseUrl + "PopupMaster/InsertPopUpMasterGeneral",
      payload);

  }

  getFitnessCheckList() {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/GetFitnesStatus");
  }
  GetFitnessCheckUpDetail() {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkup/GetFitnessApprovalByVisitId/" + this.visitid);
  }

  SaveFitnessCheckupData(payload: any) {
    return this.http.post(this.dashboardService.newbaseUrl + "DoctorWorkup/InsertFitnessApproval",
      payload);

  }
  GetPopupMasterHelp(parameter) {
    return this.http.get(this.dashboardService.newbaseUrl + "PopupMaster/getPop/" + parameter);
  }

  //insert dosage master

  InsertDosageMaster(payload) {
    return this.http.post(this.dashboardService.newbaseUrl + "MedicineMaster/InsertDosageMaster", payload);
  }
  GetDosageTimeDetailByDosageId(DosageId) {
    return this.http.get(this.dashboardService.newbaseUrl + "MedicineMaster/GetDosageTimeDetailByDosageId/" + DosageId);
  }

  GetDosageDescriptionMasterByDosageId(DosageId) {
    return this.http.get(this.dashboardService.newbaseUrl + "MedicineMaster/GetDosageDescriptionMasterByDosageId/" + DosageId);
  }

  // patient Overview
  getPlannedVisit() {
    return this.http.get(this.dashboardService.newbaseUrl + "OpdAppointment/GetFutureAppointmentListByRegId/" + this.opdvisitService.patientdetails.pkRegId);
  }
  getPlannedProc(regid) {
    return this.http.get(this.dashboardService.newbaseUrl + "Councelor/GetBookingSurgerylistByRegId/" + regid);
  }
  getcurrentMedication() {
    return this.http.get(this.dashboardService.newbaseUrl + "OptoExamination/GetCurrentMedicineByRegId/" + this.opdvisitService.patientdetails.pkRegId);
  }
  getcurrentProblem() {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUp/GetUniqueDiagnosisByRegId/" + this.opdvisitService.patientdetails.pkRegId);
  }
  getFindRec() {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUp/GetFindingByRegId/" + this.opdvisitService.patientdetails.pkRegId + '/' + 0 + '/' + 0);
  }
  getCareVisit(visitid, docid) {
    return this.http.get(this.dashboardService.newbaseUrl + "VisitMaster/GetVisitTable/" + this.opdvisitService.patientdetails.pkRegId + '/' + visitid + '/' + docid + '/' + this.authService.Loggeduser.specialityId);
  }
  getEyeProc() {
    return this.http.get(this.dashboardService.newbaseUrl + "IPDWorkup/GetOtRecordSurgeryByRegIdBySurgeryStatus/" + this.opdvisitService.patientdetails.pkRegId + "/DONE");
  }
  getPastHistory() {
    return this.http.get(this.dashboardService.newbaseUrl + "HistoryGeneral/" + this.opdvisitService.patientdetails.pkRegId);
  }
  getDiseaseHistory() {
    return this.http.get(this.dashboardService.newbaseUrl + "HistoryDisease/HistoryDisease/" + this.opdvisitService.patientdetails.pkRegId);
  }
  getFamilyHistory() {
    return this.http.get(this.dashboardService.newbaseUrl + "HistoryFamily/" + this.opdvisitService.patientdetails.pkRegId);
  }
  getTreatmentPlan() {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkup/GetOPDDrExaminationByRegId/" + this.opdvisitService.patientdetails.pkRegId + '/' + 0 + '/' + 0);
  }
  getIOPDetails() {
    return this.http.get(this.dashboardService.newbaseUrl + "IopDetail/GetIopDetailByRegID/" + this.opdvisitService.patientdetails.pkRegId);
  }
  getInjectionDetails() {
    return this.http.get(this.dashboardService.newbaseUrl + "IPDWorkup/GetOtRecordSurgeryByRegIdByOperationType/" + this.opdvisitService.patientdetails.pkRegId + "/INJECTION");
  }

  getOptobyRegId(regid) {
    return this.http.get(this.dashboardService.newbaseUrl + "OptoExamination/GetOptoByRegId/" + regid);
  }
  getOtRedId(regid) {
    return this.http.get(this.dashboardService.newbaseUrl + "IPDWorkup/GetOtRegisterByRegId/" + regid);
  }
  // status update
  historyStatus(vistid: any) {
    return this.http.get(this.dashboardService.newbaseUrl + "Audit/GetHistoryStatusByRegId/" + this.opdvisitService.patientdetails.pkRegId + '/' + vistid);
  }

  getHistoryStatus(visitid: any) {
    this.dashboardService.subscriptions = this.historyStatus(visitid).subscribe(data => this.success_historyStatus(data), err => this.failedhistoryStatus(err)
    )
  }
  historycount: number = 0
  success_historyStatus(data) {
    this.historyStatusresult = [];
    // this.historycount=0;
    // if(this.webMenuPermission.length >0){
    //   var historycountdata =this.webMenuPermission.filter(item =>item.webMenuGroupName.toLowerCase()=='history' && item.pk_WebMenuUserPermissionDetailId >0 && item.webMenuTypeId==3);
    //   this.historycount=historycountdata.length;
    // }
    this.historyStatusresult = data;
    let historystatus = this.historyStatusresult[0];
    // const values = Object.keys(historystatus).map(key => historystatus[key]);
    // const commaJoinedValues = values.filter(item=>item==1);
    if (historystatus.pastHistory == 1 && historystatus.surgicalHistory == 1 && historystatus.familyHistory == 1 &&
      historystatus.drugAllergy == 1 && historystatus.otherInformation == 1 && historystatus.socialHistory == 1) {
      this.clsactive = 'Complete';
    } else if (historystatus.pastHistory == 0 && historystatus.surgicalHistory == 0 && historystatus.familyHistory == 0 &&
      historystatus.drugAllergy == 0 && historystatus.otherInformation == 0 && historystatus.socialHistory == 0) {
      this.clsactive = 'pending';
    } else {
      this.clsactive = 'pcomplete';
    }
  }
  failedhistoryStatus(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  drWorkupExamStatus(visitid, examid) {

    this.dashboardService.subscriptions = this.http.get(this.dashboardService.newbaseUrl + "Audit/GetDoctorWorkUpStatusByRegIdByVisitIdByExamId/" + this.opdvisitService.patientdetails.pkRegId + '/' + visitid + '/' + examid).subscribe(data => this.success_drworkupstatus(data), error => this.failed_drworkupstatus(error));
  }
  success_drworkupstatus(data) {
    this.drWorkupStatus = {};
    if (data.length > 0) {
      this.drWorkupStatus = data[0];
      if (this.drWorkupStatus.findingExamination == 1 && this.drWorkupStatus.investigation == 1 && this.drWorkupStatus.diagnosis == 1
        && this.drWorkupStatus.medicine == 1 && this.drWorkupStatus.surgery == 1 && this.drWorkupStatus.review == 1 && this.drWorkupStatus.otherInformation == 1) {
        this.drclassactive = 'Complete';
      } else if (this.drWorkupStatus.findingExamination == 0 && this.drWorkupStatus.investigation == 0 && this.drWorkupStatus.diagnosis == 0
        && this.drWorkupStatus.medicine == 0 && this.drWorkupStatus.surgery == 0 && this.drWorkupStatus.review == 0 && this.drWorkupStatus.otherInformation == 0) {
        this.drclassactive = 'pending';
      } else {
        this.drclassactive = 'pcomplete';
      }
    }
  }
  failed_drworkupstatus(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  primaryExamStatus() {
    return this.http.get(this.dashboardService.newbaseUrl + "Audit/GetPrimaryExamStatusByRegIdByVisitId/" + this.opdvisitService.patientdetails.pkRegId + '/' + this.visitid);
  }

  getPExamStatus() {
    this.dashboardService.subscriptions = this.primaryExamStatus().subscribe(data => this.success_pExamStatus(data), error => this.failedPExamStatus(error))
  }


  success_pExamStatus(data) {
  this.pExamStatus = data || [];
  this.pExamStatusChk = this.pExamStatus[0] || {};
  
  const chk = this.pExamStatusChk;

  const commonFields = [
    'presentingComplaints',
    'intraocularPressure',
    'oldGlass',
    'vision',
    'unDilatedAndDilated',
    'glassPrescription',
    'opdTest',
    'advisedInvestigations',
    'optoSlitLampExamination',
    'otherInformation',
    'currentMedication'
  ];

  const altFields = ['autoRefractionDetails', 'keratometerReadings'];

  const allOnes = commonFields.every(key => chk[key] === 1) &&
                  (chk[altFields[0]] === 1 || chk[altFields[1]] === 1);

  const allZeros = commonFields.every(key => chk[key] === 0) &&
                   chk[altFields[0]] === 0 && chk[altFields[1]] === 0;

  if (allOnes) {
    this.pxclsactive = 'Complete';
  } else if (allZeros) {
    this.pxclsactive = 'pending';
  } else {
    this.pxclsactive = 'pcomplete';
  }
}

  failedPExamStatus(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    }
    else if (err.error.statusCode == 422) {
      this.dashboardService.openSnackBar(err.error.message, "OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }
  getMasterSite() {
    return this.http.get(this.dashboardService.newbaseUrl + "Common/GetSite");
  }
  // Complaint Master
  getAllComplaints(type, searchtype) {
    return this.http.get(this.dashboardService.newbaseUrl + "ComplaintMaster/GetComplaint/0/" + type + '/' + searchtype);
  }
  InsertComplaintMaster(payload) {
    return this.http.post(this.dashboardService.newbaseUrl + "ComplaintMaster/InsertComplaintMaster", payload);
  }
  getOpType() {
    // AutoRef/GetARdata/visitId
    return this.http.get(this.dashboardService.newbaseUrl + "Common/GetPostOpTypeMasterById/0")
  }


  // Counselor
  getUserTypeId() {
    return this.http.get(this.dashboardService.newbaseUrl + "UserMaster/GetUserByUserTypeId/" + 6);
  }

  getSugeryStatus() {
    return this.http.get(this.dashboardService.newbaseUrl + "SurgeryMaster/GetSurgeryStatusMaster/All");
  }

  getPartytAll() {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "PartyMaster/GetPartyAll")
  }

  getRateType() {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "RateType/GetRateTypeList");
  }
  inhouseSurgeries(RegId) {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUp/GetIPDSurgeryByRegId/" + RegId);
  }
  inhouseInvestigation(RegId) {
    return this.http.get(this.dashboardService.newbaseUrl + "Procedure/GetProcedureRegisterByRegId/" + RegId);
  }

  GETOPDDrInvestigationTemplateMaster(templateId, drId) {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/GETOPDDrInvestigationTemplateMasterByIdByDoctorId/" + templateId + '/' + drId);
  }

  GETOPDDrInvestigationTemplateDetailByTemplateId(templateId) {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/GETOPDDrInvestigationTemplateDetailByTemplateId/" + templateId);
  }
  InsertOPDDrInvestigationTemplateMaster(payload) {
    return this.http.post(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/InsertOPDDrInvestigationTemplateMaster", payload);
  }

  getOptoTestDetails() {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "OptoExamination/GetOpdOptoTestDetailByVisitId/" + this.opdvisitService.visitid);
  }

  getProcedureData(regid) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "Procedure/GetProcedureRegisterByRegId/" + regid);
  }

  saveOpdOptoTestDetail(payload) {
    return this.http.post<any>(this.dashboardService.newbaseUrl + "OptoExamination/InsertOpdOptoTestDetail", payload);
  }

  getOptoInvestigationsDetail() {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "OptoExamination/GetOpdOptoInvestigationsDetailByVisitId/" + this.opdvisitService.visitid);
  }

  saveOpdOptoInvestigationsDetail(payload) {
    return this.http.post<any>(this.dashboardService.newbaseUrl + "OptoExamination/InsertOpdOptoInvestigationsDetail", payload);
  }
  historyPermission: WebmenupermissionModel = {};
  pasthistoryPermission: WebmenupermissionModel = {};
  surgicalhistoryPermission: WebmenupermissionModel = {};
  familyhistoryPermission: WebmenupermissionModel = {};
  drughistoryPermission: WebmenupermissionModel = {};
  socialhistoryPermission: WebmenupermissionModel = {};
  otherhistoryPermission: WebmenupermissionModel = {};
  primaryExamPermission: WebmenupermissionModel = {};
  PresentingComplaintsPermission: WebmenupermissionModel = {};
  autorefkeroPermission: WebmenupermissionModel = {};
  intraocularPressurePermission: WebmenupermissionModel = {};
  oldGlassPermission: WebmenupermissionModel = {};
  visionPermission: WebmenupermissionModel = {};
  currentMPermission: WebmenupermissionModel = {};
  unDilatedAndDilatedPermission: WebmenupermissionModel = {};
  glassPrescriptionPermission: WebmenupermissionModel = {};
  optometristPermission: WebmenupermissionModel = {};
  optoSliptLampPermission: WebmenupermissionModel = {};
  advisedInvestigationsPermission: WebmenupermissionModel = {};
  postOpInformationPermission: WebmenupermissionModel = {};
  doctorPermission: WebmenupermissionModel = {};
  findingPermission: WebmenupermissionModel = {};
  investigationPermission: WebmenupermissionModel = {};
  diagnosisPermission: WebmenupermissionModel = {};
  medicinePermission: WebmenupermissionModel = {};
  surgeryPermission: WebmenupermissionModel = {};
  reviewPermission: WebmenupermissionModel = {};
  otherInformationPermission: WebmenupermissionModel = {};
  counselorPermission: WebmenupermissionModel = {};
  procedurePermission: WebmenupermissionModel = {};
  getemrPermissionuserid() {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "UserMaster/GetWebMenuUserPermissionDetail");
  }

  GetOpdVisitFinding(visitid) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "OptoExamination/GetOpdVisitFindingDetailByVisitId/" + visitid);
  }
  InsertupdatedeletesplitLamp(payload) {
    return this.http.post(this.dashboardService.newbaseUrl + "OptoExamination/InsertOpdVisitFindingDetail", payload);
  }
  GetNormalFindingTemplate(TemplateId) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/GetNormalFindingTemplateDetailByTemplateId/" + TemplateId);
  }
  GetOpdCurrentMedication(visitId) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "OptoExamination/GetOpdCurrentMedicationDetailByVisitId/" + visitId);
  }
  InsertOpdCurrentMedication(payload) {
    return this.http.post(this.dashboardService.newbaseUrl + "OptoExamination/InsertOpdCurrentMedicationDetail", payload);
  }
  InsertOpdTracking(payload) {
    return this.http.post(this.dashboardService.newbaseUrl + "VisitMaster/InsertOpdTracking", payload);
  }
  savedrWorkupTrackingSatus(remarks, edittype, type) {
    const currrentdate = JSON.parse(sessionStorage.getItem('SessiondateTime'));
    if (type == 'DR') {
      var checkstarttime = this.holdtimeDoctor ? this.holdtimeDoctor : currrentdate;
    } else if (type == 'CS') {
      var checkstarttime = this.holdtimeCounselor ? this.holdtimeCounselor : currrentdate;
    } else if (type == 'PR') {
      var checkstarttime = this.holdtimeprocedure ? this.holdtimeprocedure : currrentdate;
    }

    let payload = {
      "OpdTracking": {
        "StartTime": moment(checkstarttime).format("HH:mm:ss"),
        "FinishTime": moment(currrentdate).format("HH:mm:ss"),
        "LocationId": 6,
        "VisitId": this.opdvisitService.visitid,
        "UserId": this.authService.Loggeduser.userid,
        "Remarks": remarks,
        "Type": type,
        "Total": 0,
        "UpdateTotal": true,
        "OnlyEntry": false,
        "UpdateLocationId": false,
        "SelectedUserId": 0,
        "IsEdit": edittype

      }

    }
    this.InsertOpdTracking(payload).subscribe(x => {
      if (type == 'PR') {
        this.getPExamStatus();
      }

    })
  }
  GetdiagonsisDept() {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "Common/GetDiagnosisDeptMaster/" + 0);
  }
  GetNormalFindingTemplateM(tempateId) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/GetNormalFindingTemplateMasterById/" + tempateId);
  }
  InsertNormalFindingTemplate(payload) {
    return this.http.post(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/InsertNormalFindingTemplate", payload);
  }
  InsertDiseaseMaster(payload) {
    return this.http.post(this.dashboardService.newbaseUrl + "DiseaseMaster/InsertDiseaseMaster", payload);
  }
  add_dashboard_remark(payload: any) {
    return this.http.post<any>(this.dashboardService.newbaseUrl + "VisitMaster/AddRemark", payload);
  }
  uploadDoc(formdata) {
    return this.http.post(this.dashboardService.newbaseUrl + "Document/UploadFile", formdata);
  }
  getImagedata(tranid, brachid, folder) {
    return this.http.get(this.dashboardService.newbaseUrl + "Document/GetAllFiles/" + tranid + '/' + brachid + '/' + folder);
  }
  getiolDetail(type) {
    return this.http.get(this.dashboardService.newbaseUrl + "Common/GetNameByType/" + type);
  }

  GetArNctPath(branchid: any, machinetype: any) {
    return this.http.get(this.dashboardService.newbaseUrl + "Configuration/GetArNctPath/" + branchid + '/' + machinetype);
  }
  getiolsaveData(iolid, visitid) {
    return this.http.get(this.dashboardService.newbaseUrl + "DoctorWorkUp/GetOpdIolPowerByIdByVisitId/" + iolid + '/' + visitid);

  }
  insertiolData(formdata) {
    return this.http.post(this.dashboardService.newbaseUrl + "DoctorWorkUp/InsertOpdIolPower", formdata);
  }
  getiomethods(type, searchtype) {
    return this.http.get<IoMethods>(this.dashboardService.newbaseUrl + "IopMethodMaster/GetAll/" + type + '/' + searchtype);
  }
  getsalthName(type, searchtype) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "SaltMaster/GetAllSalt/" + type + '/' + searchtype);
  }
  getbysubgroupud(maingroupid) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/GetFindingSubGroupByGroupId/" + maingroupid);
  }
  getfindingdatabysubgid(subgroupid) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/GetFindingBySubGroupId/" + subgroupid);
  }
  getfindingresultbyfindingid(reultgroupid) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "DoctorWorkUpMaster/GetFindingResultByFindingId/" + reultgroupid);
  }
  GetWebReportPrint(data) {
    return this.http.post<any>(this.dashboardService.newbaseUrl + "Configuration/GetWebReportPrintMasterByModuleByPrintOptionByPrintType", data);
  }
  getquliferdetailid(qualifierid: any) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "SurgeryMaster/GetSurgeryQualifierMaster/" + qualifierid);
  }
  InsertSlitLampImageDetail(payload: any) {
    return this.http.post<any>(this.dashboardService.newbaseUrl + "DoctorWorkUp/InsertSlitLampImageDetail", payload);
  }
  GetSlitLampImageDetailByIdByExamId(ImageDetailById: any, ExamId: any) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "DoctorWorkUp/GetSlitLampImageDetailByIdByExamId/" + ImageDetailById + '/' + ExamId);
  }
  // procedure apis
  GetRegisterMasterByRegisterType() {
    return this.http.get(this.dashboardService.newbaseUrl + "Procedure/GetRegisterMasterByRegisterType/PROCEDURE");
  }
  GetBillDetailByRegID(regId) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "Procedure/GetBillDetailByRegID/" + regId);
  }
  GetProcedureRegisterDetailByFkTransactionId(tranId) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "Procedure/GetProcedureRegisterDetailByFkTransactionId/" + tranId);
  }
  GetRegisterSourceDetailByBranchIdByFkRegisterId(branchId, regId) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "PROCEDURE/GetRegisterSourceDetailByBranchIdByFkRegisterId/" + branchId + '/' + regId);
  }
  GetRegisterFieldDetailByFkRegisterId(fkregid) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "Procedure/GetRegisterFieldDetailByFkRegisterId/" + fkregid);
  }

  GetInvestigationDetailByRegIdByVisitId(regId, visitId) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "Procedure/GetInvestigationDetailByRegIdByVisitId/" + regId + '/' + visitId);
  }

  addprocedure(payload) {
    return this.http.post(this.dashboardService.newbaseUrl + "Procedure/InsertProcedure", payload)
  }
  addinv(payload) {
    return this.http.post(this.dashboardService.newbaseUrl + "Procedure/UpdateOpdDrInvestigationsDetail", payload)
  }
  GetDischargeOrDoctorPrescriptionDetail(byRegid: any) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "OptoExamination/GetDischargeOrDoctorPrescriptionDetailForLastIDByRegID/" + byRegid);
  }
  doctorWorkupGetDischargePrescriptionDetail(byRegid: any) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "DoctorWorkup/GetDischargePrescriptionDetailForLastIPDIDByRegID/" + byRegid);
  }
  timecheck: any;
  convertTime12Hour(time) {
    this.timecheck = null;
    this.timecheck = this.datePipe.transform(time, "HH:mm:ss");
    if (this.timecheck != null && this.timecheck != '') {
      let hour = (this.timecheck.split(':'))[0]
      let min = (this.timecheck.split(':'))[1]
      let part = hour >= 12 ? 'PM' : 'AM';

      min = (min + '').length == 1 ? `0${min}` : min;
      hour = hour > 12 ? hour - 12 : hour;
      hour = (hour + '').length == 1 ? `0${hour}` : hour;

      return (`${hour}:${min} ${part}`)
    } else {
      return null;
    }

  }
  // Get the list of available cameras
  getCameraList(): Promise<MediaDeviceInfo[]> {
    return new Promise((resolve, reject) => {
      navigator.mediaDevices.enumerateDevices()
        .then(devices => {
          // Filter out only video input devices (cameras)
          const videoDevices = devices.filter(device => device.kind === 'videoinput');
          resolve(videoDevices);
        })
        .catch(err => reject(err));
    });
  }
  hasDuplicateIds(arr: any[], key: string = 'id'): boolean {
    const uniqueIds = new Set();
    return arr.some(item => {
      const idValue = item[key];
      if (uniqueIds.has(idValue)) {
        return true; // Duplicate found
      }
      uniqueIds.add(idValue);
      return false;
    });
  }
  Gettransferfindingreocrdregid(fkregid) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "DoctorWorkUp/GetFindingForLastVisitIDByRegID/" + fkregid);
  }
  GettransferMedincereocrdregid(fkregid) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "DoctorWorkUp/GetPrescriptionDetailForLastVisitIDByRegID/" + fkregid);
  }
  Gettransferdaigonsisreocrdregid(fkregid) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "DoctorWorkUp/GetDiagnosisForLastVisitIDByRegID/" + fkregid);
  }

}
